import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/Services/project.service';
import { UserService } from 'src/app/Services/user.service';
import { TokenEncryptionService } from 'src/app/Services/token-encryption.service';
import { WindowRefService } from 'src/app/Services/window-ref.service';
import { WoocommerceService } from 'src/app/Services/woocommerce.service';
import swal from 'sweetalert2';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { BillingProfileModalComponent } from 'src/app/components/billing-profile-modal/billing-profile-modal.component';
import { forkJoin, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { SweetAlertService } from 'src/app/Services/sweet-alert.service';
import { DeviceDetectionService } from 'src/app/Services/device-detection.service';
import { PhoneVerificationService } from 'src/app/Services/phone-verification.service';
import { PhoneVerificationModalComponent } from 'src/app/components/phone-verification-modal/phone-verification-modal.component';
import { hasCompanyRole } from 'src/app/utils/role.utils';
import {
  checkoutTaxPrefillFromSavedTaxNo,
  formatBillingPeriodOnly,
  formatInrCheckoutAmount,
  formatSubscriptionNextCharge,
  isProductTierDowngrade,
  normalizeProductTierCode,
  parseBillingAmount,
  planCodeDisplayName,
  productTierRank,
  readAutoRenewEnabled,
  resolveBillingPeriodSlug,
} from 'src/app/utils/billing-display.util';
import {
  billingPeriodLabelToSlug,
  BillingPeriodSlug,
  effectiveMonthlyFromPrepaid,
  findBundledSeatProduct,
  nextBandHint,
  periodDisplayName,
  periodOptions,
  periodTermLabel,
  PeriodOption,
  readProductInrPrice,
  readProductUsdPrice,
  resolveWcCurrencyScope,
  WcSeatProduct,
} from 'src/app/utils/plan-wc-product.util';
import { ENTITLEMENT_LABELS, EntitlementKey } from 'src/app/entitlements/entitlement-keys';
import { UserWithEntitlements } from 'src/app/entitlements/entitlements.types';
import { EntitlementsService } from 'src/app/Services/entitlements.service';
import { SettingsEntitlementsService } from 'src/app/Services/settings-entitlements.service';
import { CompanyAddOnEntitlement } from 'src/app/entitlements/settings-entitlements.types';
import {
  PlanTierCard,
  PlansCatalogResponse,
  ProductTierChangeResponse,
} from '../plan-tier.types';
import { PlanUpgradeDialogComponent } from 'src/app/components/plan-upgrade-dialog/plan-upgrade-dialog.component';
import {
  DowngradeValidationDialogComponent,
  DowngradeValidationDialogData,
  DowngradeValidationDialogResult,
} from 'src/app/components/downgrade-validation-dialog/downgrade-validation-dialog.component';
import { PlanTransitionValidationService } from 'src/app/Services/plan-transition-validation.service';
import { PlanTransitionValidationResponse } from '../plan-transition.types';
import { CreateRequestComponent } from 'src/app/Admin/help-and-support/create-request/create-request.component';
import { BillingAnalyticsService } from '../billing-analytics.service';
import { BillingHeroState } from '../billing-hero/billing-hero.component';
import {
  calendarDaysBetween,
  getTermEndDate,
  parseLocalCalendarDate,
  resolveBillingHeaderDate,
} from 'src/app/utils/subscription-term.util';
import { environment } from 'src/environments/environment';
import {
  PLAN_COMPARE_FOOTNOTE,
  PLAN_COMPARE_GROUPS,
  PlanCompareRow,
  PlanCompareValue,
  planCompareGains,
} from '../plan-compare.config';
import { BillingInvoice } from 'src/app/billing-invoices/billing-invoices.types';
import { LiveScreencastQuotaService } from 'src/app/Services/live-screencast-quota.service';
import { ScreencastQuotaPayload } from 'src/app/entitlements/live-screencast-quota.types';

/** How the Billing page is weighted for this account. */
export type BillingPageMode = 'trial' | 'upgrade' | 'top' | 'attention';

export interface PlanLimitMeter {
  label: string;
  used: number;
  max: number;
  unit: string;
}

@Component({
  selector: 'app-user-plans',
  templateUrl: './user-plans.component.html',
  styleUrl: './user-plans.component.css',
  providers: [DatePipe],
  standalone: false
})
export class UserPlansComponent implements OnInit, OnDestroy {
  totalUser = 0;
  totalUserCurrent = 0;
  name = '';
  email = '';
  phone_number = '';
  user = 1;
  monthlyBackground = 'monthly-btn-bg-color';
  quarterlyBackground = '';
  yearlyBackground = '';

  moreUserBackground = '';
  payAcdvanceBackground = 'monthly-btn-bg-color';
  planVal = 0;
  selected_plan_type = 'main';
  plan_id = 0;
  plan_data;
  plan_type = 'Monthly';
  /** Woo seat cadence (Monthly / Quarterly / Yearly) — not product tier. */
  subscriptionBillingPeriod = 'Monthly';

  order_Id = '';
  monthly_price = 0;
  quarterly_price = 0;
  yearly_price = 0;
  monthly_usd_price = 0;
  quarterly_usd_price = 0;
  yearly_usd_price = 0;
  /** Display: amortized monthly rate for prepaid terms. */
  display_unit_price_inr = 0;
  display_unit_price_usd = 0;
  selected_price = 0;
  selected_usd_price = 0;
  totalUser_usd = 0;
  min = 1;
  today_date;
  expire_date;
  loading = false;
  strPlan = ''
  isButtonDisable = false;
  isAdvancePayment = false;
  isToggle = false;
  strCaption = '';
  strSubCaption = '';
  quota_status = '';
  strDateCption = '';
  strSubDateCaption = '';
  isGST = false;
  quota_allowed = 1;
  oneUserPrice = 1;
  isHint = false;
  txtGst = '';
  isGSTVerified = false;
  gstPrice = 0;
  isAdmin = true;
  useUser = 0;
  /** People on the company (employee list + company admin if needed) — seat floor. */
  activeEmployeeCount = 0;
  /** Avoid infinite auto-bump loops when quote returns seats_shortfall. */
  private seatShortfallAutoFixAttempted = false;
  billingCompanyId = 0;
  availableUser = 0;
  quotaStatus = '';
  quota_expired_date;
  currentSelectedPlant: any = "";
  /** Product tier from entitlements v2 (basic / professional / business). */
  productTierDisplay = '';
  currentPlanCode = 'professional';
  checkoutPlanCode = '';
  /** True once the user explicitly picks a tier card for checkout. */
  private checkoutTierChosenByUser = false;
  planTiers: PlanTierCard[] = [];
  planCatalogLoading = true;
  tierActionPlanCode: string | null = null;
  transitionValidationLoading = false;
  transitionValidationTargetPlanCode: string | null = null;
  selfServeTierChange = false;
  entitlementFeatureSummary = '';
  /** Features list beside seat checkout — reflects selected checkout tier from catalog. */
  tierSeatFeatures: { label: string; included: boolean }[] = [];
  tierSeatLockedTeasers: string[] = [];
  /** Seat Woo checkout panel — hidden until user chooses Add seats / Renew. */
  seatCheckoutExpanded = false;
  subscriptionDetailsExpanded = false;
  seatSectionAttention = false;
  /** Highlights Professional card when user arrives via upgrade intent. */
  highlightRecommendedTier = false;
  /** Brief highlight on the active tier card after a successful tier change. */
  highlightAppliedPlanTier = false;
  seatCheckoutPanelTitle = '';
  private pendingBillingIntent: 'seats' | 'upgrade' | null = null;
  private billingQuoteTimer: ReturnType<typeof setTimeout> | null = null;
  /** Drops a quote response that belongs to the previous country. */
  private billingQuoteSeq = 0;
  /** Drops a /users/me response that started before the latest billing-address save. */
  private userFetchSeq = 0;
  /** Address just saved in this visit. Kept until /users/me returns the same country. */
  private savedBillingAddress: {
    country: string;
    state: string;
    address_1: string;
    address_2: string;
    city: string;
    postcode: string;
  } | null = null;
  /** Last seat count already priced. Repeat input events with the same number must not reprice. */
  private lastPricedSeatCount: number | null = null;
  private periodOptionsCache: {
    seats: number;
    plan: string;
    country: string;
    products: unknown;
    options: PeriodOption[];
  } | null = null;
  private tierPriceCache: {
    key: string;
    products: unknown;
    map: Map<string, { amount: string; note: string } | null>;
  } | null = null;
  private seatAttentionTimer: ReturnType<typeof setTimeout> | null = null;
  rzp_next_renewal_date: any;
  addon_price_inr = 0;
  addon_price_usd = 0;
  addon_days_remaining = 0;

  // New properties for subscription status and renewal display
  subscription_status: string = '';
  displaySubscriptionStatusText: string = 'None';
  razorpaySubscriptionId = '';
  nextChargeAmount: number | null = null;
  nextChargeCurrency: string | null = null;
  nextChargeDate: string | null = null;
  displayAutoRenewText: string = 'Yes'; // Default to Yes
  next_renewal_label: string = 'Active until';
  renewal_notification_text: string = 'We will send you a notification upon Subscription expiration.';
  is_auto_renew_status: boolean = false; // To store boolean representation
  grace_period: number | null = null;
  adv_payment_days: number | null = null;
  trial_grace_period: number | null = null;

  subscriptionStatusDescriptions: { [key: string]: string } = {
    active: 'Subscription is successfully activated after the first payment.',
    pending: 'Subscription is created but not yet activated (e.g. awaiting first payment).',
    paused: 'Subscription is manually or automatically paused (due to failed payments, etc).',
    resumed: 'A paused subscription has been resumed, either manually or via API.',
    halted: 'Subscription is halted after multiple payment failures (auto-retry exhausted).',
    cancelled: 'Subscription was manually cancelled or cancelled via API before its natural end date.',
    completed: 'Subscription cycle is completed. A new subscription can be created.',
    default: 'Unknown subscription status.'
  };
  // End new properties

  // New properties for upgrade functionality
  auto_renew: boolean = false; // Changed to false to disable auto-renew by default
  billing_country: string = ''; // To store user's billing country
  billing_state: string = ''; // To store user's billing state
  payment_mode: string = ''; // To store payment mode (domestic/international)
  determined_tax_type: string = ''; // To store dynamically determined tax type
  totalInr = 0;
  totalUsd = 0;
  loginUserInformation: any;
  isSetDebounceTime: boolean = false;
  debounceTimeHold: number = 800;
  @ViewChild('usersLimitInput') usersLimitInput: ElementRef<HTMLInputElement>;
  isLoadingPrice: boolean = false;
  /** Seat product prices (monthly / quarterly / annual cards and the order summary). */
  seatPricesLoading = true;
  readonly priceSkeletonSlots = [1, 2, 3];
  quoteErrorMessage = '';
  /** When quote fails because seats < active people — offer “Add N seats”. */
  quoteSeatsShortfall: number | null = null;
  quoteRequiredSeats: number | null = null;
  /** Clear order-summary rows from quote days_data (replaces legacy “User's / Day's” strings). */
  summaryBreakdown: { label: string; hint?: string; amount?: string }[] = [];
  mobileSummaryExpanded = false;
  tierUpgradeProrateEnabled = false;
  pricingMode: 'standard' | 'custom' = 'standard';
  checkoutMode: 'add' | 'renew' | 'setup' | 'tier_upgrade' = 'setup';
  companyAddOns: CompanyAddOnEntitlement[] = [];
  addOnStateMessage = '';
  addOnsLoading = true;
  paymentOutcome: 'idle' | 'success' | 'failed' = 'idle';
  paymentOutcomeMessage = '';
  readonly compareGroups = PLAN_COMPARE_GROUPS;
  readonly compareFootnote = PLAN_COMPARE_FOOTNOTE;
  /** Plan picked in the phone tab switch of the comparison table. */
  compareMobileTier: string | null = null;
  recentInvoices: BillingInvoice[] = [];
  recentInvoicesLoading = true;
  recentInvoicesError = '';
  /**
   * Rail cards use their own loaders. Page `loading` flips false as soon as a
   * cached user is painted, so Billing details / Subscription must not rely on it.
   */
  billingDetailsLoading = true;
  subscriptionLoading = true;

  /**
   * True when the current tenant has no billing country/state saved. Shown as
   * an inline banner on the hero so the user can open the Billing Profile modal
   * on their own schedule instead of having it covered the page with a
   * `disableClose: true` backdrop the moment the page mounts.
   */
  needsBillingProfileFlag = false;
  /** False until /users/me (and the Woo customer, when there is one) has been read. */
  private billingProfileChecked = false;
  /** False until the fresh /users/me body has been applied (cached user does not count). */
  private billingUserFromServer = false;

  needsBillingProfile(): boolean {
    return this.billingProfileChecked && this.needsBillingProfileFlag;
  }

  /** User-initiated handler for the inline "Complete billing info" CTA. */
  onCompleteBillingInfo(): void {
    this.openBillingDialog();
  }

  /**
   * True when a country and at least one other address field are already saved.
   * Country alone is not enough — a default code must not hide the form — but
   * India + Gujarat (what the rail shows as "India · GJ") is a saved profile.
   */
  private hasSavedBillingProfile(): boolean {
    const meta = this.loginUserInformation?.meta || {};
    const addr = this.loginUserInformation?.billing_address || {};
    const country = (this.billing_country || meta.billing_country || meta.country || addr.country || '')
      .toString()
      .trim();
    const state = (this.billing_state || meta.billing_state || meta.state || addr.state || '')
      .toString()
      .trim();
    const line = (addr.address_1 || meta.billing_address_1 || '').toString().trim();
    const city = (addr.city || meta.billing_city || '').toString().trim();
    const zip = (addr.postcode || meta.billing_postcode || '').toString().trim();
    return !!(country && (state || line || city || zip));
  }

  /** null = use the page mode's default (open only for trials). */
  compareExpanded: boolean | null = null;
  /** Period used for Compare plans prices. Null → follow checkout / subscription. */
  comparePeriod: BillingPeriodSlug | null = null;
  readonly comparePeriodChoices: { period: BillingPeriodSlug; label: string }[] = [
    { period: 'monthly', label: 'Monthly' },
    { period: 'quarterly', label: 'Quarterly' },
    { period: 'yearly', label: 'Annual' },
  ];
  private screencastQuota: ScreencastQuotaPayload | null = null;
  /** Set on destroy so late dialog callbacks do not rewrite the URL of another page. */
  private destroyed = false;
  private addOnEmployeeNamesById = new Map<number, string>();
  private billingViewTracked = false;
  private gstinTracked = false;

  constructor(
    private router: Router,
    public _dialog: MatDialog,
    private _projectService: ProjectService,
    private _wrs: WindowRefService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private woocommerceService: WoocommerceService,
    private http: HttpClient,
    private location: Location,
    private sweetAlertService: SweetAlertService,
    private deviceDetectionService: DeviceDetectionService,
    private phoneVerificationService: PhoneVerificationService,
    private entitlementsService: EntitlementsService,
    private settingsEntitlementsService: SettingsEntitlementsService,
    private planTransitionValidationService: PlanTransitionValidationService,
    private route: ActivatedRoute,
    public billingAnalytics: BillingAnalyticsService,
    private liveScreencastQuotaService: LiveScreencastQuotaService,
    private userService: UserService,
    private tokenEncryptionService: TokenEncryptionService,
    private cdr: ChangeDetectorRef
  ) {
    this.isAdvancePayment = false;
    this.onPageShow = (event: PageTransitionEvent) => {
      // Chrome restores a frozen document from the back-forward cache. Timers
      // and in-flight HTTP from that snapshot are dead, so the skeleton stays
      // up. Paint again from the user we already have.
      if (event.persisted) {
        this.revealFromKnownUser();
      }
    };
  }

  private onPageShow: (event: PageTransitionEvent) => void;

  /**
   * Hard safety net: if some downstream HTTP (WC products, WC customer, WP /users/me)
   * stalls for a trial account, we flip loading off anyway so the user sees the hero
   * and real messaging instead of an endless skeleton. 6 s is longer than any of the
   * individual rxjs timeouts above, so this only fires when the whole chain is broken.
   */
  private loadingSafetyTimer: ReturnType<typeof setTimeout> | null = null;

  /**
   * Dialogs this component opens are `disableClose: true`, so they survive a
   * route change if the user clicks a sidebar link while a modal is up. Those
   * orphaned dialogs stay mounted in the global CDK overlay and (a) steal
   * clicks on revisit and (b) make a new copy stack on top. We track every
   * dialog this component opens so ngOnDestroy can tear them down cleanly.
   */
  private openOwnedDialogs: MatDialogRef<any>[] = [];

  private trackDialog<T>(ref: MatDialogRef<T>): MatDialogRef<T> {
    this.openOwnedDialogs.push(ref);
    ref.afterClosed().subscribe({
      next: () => {
        this.openOwnedDialogs = this.openOwnedDialogs.filter((r) => r !== ref);
      },
      error: () => {
        this.openOwnedDialogs = this.openOwnedDialogs.filter((r) => r !== ref);
      },
    });
    return ref;
  }

  private closeOwnedDialogs(): void {
    const refs = this.openOwnedDialogs.slice();
    this.openOwnedDialogs = [];
    for (const ref of refs) {
      try {
        ref.close();
      } catch {
        // ignore — already closed
      }
    }
  }

  ngOnInit(): void {
    const t0 = performance.now();
    const navEntry = performance.getEntriesByType('navigation')[0] as
      | PerformanceNavigationTiming
      | undefined;
    console.info('[Billing] ngOnInit start', {
      navKind: navEntry?.type ?? 'spa',
      url: this.router.url,
      strayOverlayDialogs: this._dialog.openDialogs.length,
    });

    // Belt & suspenders: close any dialog MatDialog is still holding from a
    // previous route (e.g. user clicked the sidebar while BillingProfileModal
    // was open — disableClose:true means it never got closed and the overlay
    // backdrop sits over the newly rendered page, making it look frozen).
    if (this._dialog.openDialogs.length) {
      console.warn(
        '[Billing] closing',
        this._dialog.openDialogs.length,
        'stale dialog(s) from previous route before mounting Billing.'
      );
      this._dialog.closeAll();
    }

    // Bust the `/users/me` cache for every entry to Billing. The cached user
    // object is mutated in-place by `applyBillingLocationFromUser` (which writes
    // into `data.meta` and `data.billing_address`), so on a second visit via
    // the sidebar we'd otherwise be reading a slightly different shape than we
    // did on first mount. A fresh HTTP keeps the two paths identical and
    // guarantees the Billing page sees the latest server-side billing state.
    // Cost: one extra /users/me request per Billing visit (~small payload).
    this.userService.clearOnlyCache();
    window.addEventListener('pageshow', this.onPageShow);

    // Ensure auto-renew is disabled by default for new users
    this.auto_renew = false;

    this.route.queryParamMap.subscribe((params) => {
      const intent = params.get('intent');
      if (intent === 'seats' || intent === 'upgrade') {
        this.pendingBillingIntent = intent;
      }
    });

    this.loadingSafetyTimer = setTimeout(() => {
      const railStuck =
        this.billingDetailsLoading ||
        this.subscriptionLoading ||
        this.addOnsLoading ||
        this.recentInvoicesLoading;
      if (this.loading || railStuck) {
        console.warn('[Billing] loading safety timeout tripped — forcing render.', {
          elapsedMs: Math.round(performance.now() - t0),
          planCatalogLoading: this.planCatalogLoading,
          isAdmin: this.isAdmin,
          hasUser: !!this.loginUserInformation,
          hasPlanData: Array.isArray(this.plan_data) ? this.plan_data.length : 'n/a',
          billingDetailsLoading: this.billingDetailsLoading,
          subscriptionLoading: this.subscriptionLoading,
          addOnsLoading: this.addOnsLoading,
          recentInvoicesLoading: this.recentInvoicesLoading,
        });
        this.loading = false;
        this.markRailUserSectionsReady();
        this.addOnsLoading = false;
        this.recentInvoicesLoading = false;
        this.cdr.markForCheck();
      }
      this.loadingSafetyTimer = null;
    }, 6000);

    // Do not paint or open dialogs inside this hook. On a click from Dashboard
    // the URL is already /billings and this component already exists, but the
    // outlet is still drawing Dashboard. Touching the view here aborts that
    // swap. A direct /billings load has no previous page, so it never shows.
    // Wait until this turn finishes, then load and force one full repaint.
    setTimeout(() => this.startBillingLoad(t0));
  }

  private startBillingLoad(t0: number): void {
    if (this.destroyed) {
      return;
    }
    this.resetRailSectionLoaders();
    this.revealFromKnownUser();
    this.getPlanDetail();
    this.getUser();
    this.loadPlanCatalog();
    console.info('[Billing] startBillingLoad', {
      elapsedMs: Math.round(performance.now() - t0),
      url: this.router.url,
    });
    // markForCheck only. detectChanges / ApplicationRef.tick during this
    // navigation leaves the previous page's DOM in place.
    this.cdr.markForCheck();
  }

  /** Show per-card skeletons until each rail section has its own data. */
  private resetRailSectionLoaders(): void {
    this.addOnsLoading = true;
    this.recentInvoicesLoading = true;
    this.recentInvoicesError = '';
    this.billingDetailsLoading = true;
    this.subscriptionLoading = true;
  }

  private markRailUserSectionsReady(): void {
    this.billingDetailsLoading = false;
    this.subscriptionLoading = false;
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    window.removeEventListener('pageshow', this.onPageShow);
    if (this.billingQuoteTimer) {
      clearTimeout(this.billingQuoteTimer);
      this.billingQuoteTimer = null;
    }
    if (this.seatAttentionTimer) {
      clearTimeout(this.seatAttentionTimer);
      this.seatAttentionTimer = null;
    }
    if (this.loadingSafetyTimer) {
      clearTimeout(this.loadingSafetyTimer);
      this.loadingSafetyTimer = null;
    }
    // Tear down any `disableClose: true` dialogs this component opened so the
    // CDK overlay doesn't carry them (and their backdrops) into the next route.
    this.closeOwnedDialogs();
  }

  cancelSubscriptionAction() {
    swal.fire({
      title: 'Cancel your subscription?',
      html: '<p>Your current plan will stop.</p><div class="ss-impact danger"><strong>This can\'t be undone</strong>You won\'t be able to restore this subscription from here.</div>',
      showCancelButton: true,
      confirmButtonColor: '#f20606',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Cancel subscription',
      cancelButtonText: 'Keep subscription',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;

        this._projectService.cancelSubscription().subscribe({
          next: (response) => {
            this.loading = false;
            if (response && (response.status === 'cancelled' || response.message === 'Subscription cancelled successfully.' || response.success || response.data?.status === 'cancelled')) {
              swal.fire({
                icon: 'success',
                title: 'Subscription cancelled',
                text: 'Your subscription has been cancelled.',
                confirmButtonText: 'Done',
              }).then(() => {
                window.location.reload();
              });
            } else {
              swal.fire({
                icon: 'error',
                title: "Couldn't cancel the subscription",
                text: 'Try again. If this keeps happening, contact support.',
                confirmButtonText: 'Close',
              });
              this._snackBar.open("Couldn't cancel the subscription. Try again.", 'Close', { duration: 8000 });
            }
          },
          error: (error) => {
            this.loading = false;
            swal.fire({
              icon: 'error',
              title: "Couldn't cancel the subscription",
              text: 'Try again. If this keeps happening, contact support.',
              confirmButtonText: 'Close',
            });
            this._snackBar.open("Couldn't cancel the subscription. Try again.", 'Close', { duration: 8000 });
            console.error('Error cancelling subscription:', error);
          }
        });
      }
    });
  }

  sendPaymentRequest() {
    this.checkPlanDetail()
  }

  moveToBillingInvoices() {
    this.router.navigate(['/billing-invoices']);
  }

  /** Last three invoices shown on the page; the full list stays on the invoices page. */
  loadRecentInvoices(): void {
    this.recentInvoicesLoading = true;
    this.recentInvoicesError = '';
    // Independent 15 s wait: if the invoices endpoint hangs, this section
    // alone shows "Couldn't load invoices." — it never blocks the hero,
    // compare plans, seat checkout, or add-ons from rendering.
    this._projectService
      .getBillingInvoices({ source: 'all', status: 'all', page: 1, limit: 3 })
      .pipe(
        timeout(15000),
        catchError((err) => {
          console.warn('[Billing] recent invoices load failed/timed out.', err);
          return of({ invoices: [] });
        })
      )
      .subscribe({
        next: (response: any) => {
          this.recentInvoices = (response?.invoices || []).slice(0, 3);
          this.recentInvoicesLoading = false;
          if (!this.recentInvoices.length && !response) {
            this.recentInvoicesError = "Couldn't load invoices.";
          }
        },
        error: () => {
          this.recentInvoices = [];
          this.recentInvoicesLoading = false;
          this.recentInvoicesError = "Couldn't load invoices.";
        },
      });
  }

  invoiceAmountText(invoice: BillingInvoice): string {
    const currency = (invoice.currency || 'INR').toUpperCase();
    const prefix = currency === 'INR' ? '₹' : currency === 'USD' ? '$' : `${currency} `;
    return `${prefix}${Number(invoice.amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
  }

  invoiceStatusText(status: string): string {
    const text = (status || '').replace(/_/g, ' ');
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  private loadScreencastQuota(user: any): void {
    const companyId = this.resolveCompanyId(user);
    this.liveScreencastQuotaService.fetchQuota(companyId || undefined).subscribe({
      next: (response) => {
        this.screencastQuota = response?.success && response.quota ? response.quota : null;
      },
      error: () => {
        this.screencastQuota = null;
      },
    });
  }

  /**
   * Trials choose a plan, so the comparison leads. Paid accounts come to manage seats and
   * invoices, so the table is collapsed: lower tiers get one upgrade panel, the top tier a link.
   */
  billingPageMode(): BillingPageMode {
    const state = this.billingState();
    if (state === 'trial') {
      return 'trial';
    }
    const status = (this.subscription_status || '').toLowerCase();
    if (state === 'expired' || state === 'renew_window' || status === 'halted' || status === 'paused') {
      return 'attention';
    }
    return this.recommendedUpgradeTier() ? 'upgrade' : 'top';
  }

  isCompareOpen(): boolean {
    return this.compareExpanded ?? this.billingPageMode() === 'trial';
  }

  toggleCompare(): void {
    this.compareExpanded = !this.isCompareOpen();
    this.billingAnalytics.track('billing_primary_cta_clicked', {
      state: this.billingState(),
      action: this.compareExpanded ? 'compare_opened' : 'compare_closed',
    });
  }

  /** From reactivation checkout: open Compare plans and scroll to it. */
  openPlanPicker(): void {
    this.compareExpanded = true;
    this.billingAnalytics.track('billing_primary_cta_clicked', {
      state: this.billingState(),
      action: 'change_plan_from_checkout',
    });
    setTimeout(() => {
      const target =
        document.getElementById('product-tier-heading') ||
        document.getElementById('plan-compare-body');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 80);
  }

  /** Show "Change plan" in setup/reactivate checkout (not add-seats / renew-early). */
  showCheckoutChangePlan(): boolean {
    return (
      this.seatCheckoutExpanded &&
      this.selected_plan_type !== 'addon' &&
      (this.checkoutMode === 'setup' || this.checkoutMode === 'tier_upgrade')
    );
  }

  /** Per-seat rate under the Reactivate / Set up title. */
  checkoutPlanRateLine(): string {
    if (!this.showCheckoutChangePlan()) {
      return '';
    }
    const perSeat =
      Number(this.billing_country === 'IN' ? this.selected_price : this.selected_usd_price) || 0;
    if (!perSeat) {
      return '';
    }
    const term = periodTermLabel(billingPeriodLabelToSlug(this.plan_type));
    return `${this.money(perSeat)} per seat / ${term}`;
  }

  /** Plan limits the company is close to (80%+), the honest reason to upgrade. */
  nearPlanLimits(): PlanLimitMeter[] {
    const meters: PlanLimitMeter[] = [];
    const teamsMax = this.entitlementsService.getTeamsMax();
    if (!this.entitlementsService.isTeamsUnlimited() && teamsMax) {
      meters.push({ label: 'Teams', used: this.entitlementsService.getTeamsUsed(), max: teamsMax, unit: '' });
    }
    const quota = this.screencastQuota;
    if (quota && !quota.live_screencast_unlimited && quota.live_screencast_daily_limit_minutes) {
      meters.push({
        label: 'Live screencast today',
        used: Math.round((quota.live_screencast_used_seconds_today || 0) / 60),
        max: quota.live_screencast_daily_limit_minutes,
        unit: ' min',
      });
    }
    return meters.filter((m) => m.max > 0 && m.used / m.max >= 0.8);
  }

  meterPercent(meter: PlanLimitMeter): number {
    return Math.min(100, Math.round((meter.used / meter.max) * 100));
  }

  /** Price difference to a higher tier, monthly per seat and for the company's seats. */
  tierPriceDelta(tier: PlanTierCard): { perSeat: string; total: string } | null {
    if (this.pricingMode === 'custom') {
      return null;
    }
    const target = this.tierSeatPrice(tier.plan_code);
    const current = this.tierSeatPrice(this.currentPlanCode);
    if (!target || !current) {
      return null;
    }
    const perSeat = Math.round((target.monthly - current.monthly) * 100) / 100;
    if (perSeat <= 0) {
      return null;
    }
    const seats = Number(this.quota_allowed) || target.seats;
    const tax = this.billing_country === 'IN' ? ' + GST' : '';
    return {
      perSeat: `+${this.priceText(perSeat)}/seat/month`,
      total: `About ${this.priceText(Math.round(perSeat * seats))}/month for your ${seats} seats${tax}`,
    };
  }

  /** The one upgrade the page offers a paid Basic/Professional company. */
  upgradeOffer(): { tier: PlanTierCard; gains: string[] } | null {
    if (this.billingPageMode() !== 'upgrade') {
      return null;
    }
    const tier = this.recommendedUpgradeTier();
    if (!tier) {
      return null;
    }
    return {
      tier,
      gains: planCompareGains(this.normalizedTierCode(this.currentPlanCode), this.compareCode(tier)).slice(0, 4),
    };
  }

  billingLocationText(): string {
    if (!this.billing_country) {
      return 'Not added';
    }
    const country = this.billing_country === 'IN' ? 'India' : this.billing_country;
    return this.billing_state ? `${country} · ${this.billing_state}` : country;
  }

  /** Prefer WP user meta / billing_address — Woo customer can be stale or empty. */
  private applyBillingLocationFromUser(data: any): void {
    const meta = data?.meta || {};
    const addr = data?.billing_address || {};
    // Keep any country/state already resolved on the component (e.g. from a prior load).
    this.billing_country =
      meta.billing_country ||
      meta.country ||
      addr.country ||
      data?.country ||
      this.billing_country ||
      '';
    this.billing_state =
      meta.billing_state ||
      meta.state ||
      addr.state ||
      data?.state ||
      this.billing_state ||
      '';
    if (!data.billing_address) {
      data.billing_address = {};
    }
    // Keep modal prefill fields aligned with what we show on the rail.
    data.billing_address.country = this.billing_country || data.billing_address.country || '';
    data.billing_address.state = this.billing_state || data.billing_address.state || '';
    data.billing_address.address_1 =
      data.billing_address.address_1 || meta.billing_address_1 || '';
    data.billing_address.address_2 =
      data.billing_address.address_2 || meta.billing_address_2 || '';
    data.billing_address.city = data.billing_address.city || meta.billing_city || '';
    data.billing_address.postcode =
      data.billing_address.postcode || meta.billing_postcode || '';
    if (!data.billing_address.phone && meta.phone_number) {
      data.billing_address.phone = meta.phone_number;
    }
    // Mirror onto meta so the modal’s meta-first lookup finds the same values.
    if (this.billing_country && !meta.billing_country) {
      meta.billing_country = this.billing_country;
    }
    if (this.billing_state && !meta.billing_state) {
      meta.billing_state = this.billing_state;
    }
  }

  /** Keep the address the customer just saved, even if /users/me is still the previous country. */
  private rememberSavedBillingAddress(billing: any): void {
    const country = (billing?.country || '').toString().trim();
    if (!country) {
      return;
    }
    this.savedBillingAddress = {
      country,
      state: (billing.state || '').toString().trim(),
      address_1: (billing.address_1 || '').toString().trim(),
      address_2: (billing.address_2 || '').toString().trim(),
      city: (billing.city || '').toString().trim(),
      postcode: (billing.postcode || '').toString().trim(),
    };
  }

  /**
   * Paint the saved country and rebuild prices for it. A following /users/me
   * that still says India must not leave rupee totals on the page.
   */
  private reapplySavedBillingAddress(): void {
    const saved = this.savedBillingAddress;
    if (!saved?.country) {
      return;
    }
    const data = this.loginUserInformation;
    const meta = data?.meta || {};
    const addr = data?.billing_address || {};
    const serverCountry = (meta.billing_country || addr.country || '').toString().trim();
    const serverState = (meta.billing_state || addr.state || '').toString().trim();
    if (serverCountry === saved.country && serverState === saved.state) {
      this.savedBillingAddress = null;
    }

    const countryChanged = this.billing_country !== saved.country;
    this.billing_country = saved.country;
    this.billing_state = saved.state;
    if (data) {
      data.meta = data.meta || {};
      data.meta.billing_country = saved.country;
      data.meta.billing_state = saved.state;
      data.billing_address = {
        ...(data.billing_address || {}),
        country: saved.country,
        state: saved.state,
        address_1: saved.address_1,
        address_2: saved.address_2,
        city: saved.city,
        postcode: saved.postcode,
      };
    }
    if (saved.country !== 'IN') {
      this.gstPrice = 0;
      this.isGST = false;
    }
    if (countryChanged || serverCountry !== saved.country) {
      this.periodOptionsCache = null;
      this.tierPriceCache = null;
      if (Array.isArray(this.plan_data) && this.plan_data.length) {
        this.applySeatProductSelectionFromCatalog();
      }
      this.calculateTotalAmount();
      this.cdr.markForCheck();
    }
  }

  getUser() {
    // Paint from the user already in memory or localStorage (the same record
    // the header used to draw "Trial expires in N days"). Browser Back and
    // menu clicks then show the page immediately. A fresh /users/me still
    // runs below. WooCommerce never gates this.
    if (!this.loginUserInformation) {
      this.revealFromKnownUser();
    }
    if (!this.loginUserInformation) {
      this.loading = true;
    }

    const seq = ++this.userFetchSeq;
    this._projectService.getUser().subscribe({
      next: (data: any) => {
        // A save can start a newer fetch while this one is still in flight.
        // Applying the older body puts India prices back on a US address.
        if (seq !== this.userFetchSeq || this.destroyed) {
          return;
        }
        this.consumeUserPayload(this.cloneUser(data), true);
      },
      error: (err) => {
        if (seq !== this.userFetchSeq || this.destroyed) {
          return;
        }
        this.loading = false;
        this.billingUserFromServer = true;
        // Cached paint may already show the rail; still clear section loaders
        // so a failed /users/me does not leave skeletons forever.
        this.markRailUserSectionsReady();
        if (this.recentInvoicesLoading) {
          this.recentInvoicesLoading = false;
        }
        if (this.addOnsLoading) {
          this.addOnsLoading = false;
        }
        console.error('Error fetching user data:', err);
        this.finishBillingProfileCheck();
        this.cdr.markForCheck();
      },
    });
  }

  /** User the header already has, copied so Billing cannot mutate the shared object. */
  private revealFromKnownUser(): void {
    const known = this.readKnownUser();
    if (known) {
      // Paint only. The stored user often has no billing address yet, and
      // prompting from it opens "add billing details" over a company that
      // already saved India / Gujarat. The fresh /users/me response decides.
      this.consumeUserPayload(known);
    }
  }

  private readKnownUser(): any | null {
    const fromMemory = this.userService.getCurrentUserValue();
    if (fromMemory) {
      return this.cloneUser(fromMemory);
    }
    const stored =
      this.tokenEncryptionService.getEncryptedItem<any>('user') ||
      this.tokenEncryptionService.getEncryptedItem<any>('logedInUser');
    return stored ? this.cloneUser(stored) : null;
  }

  private cloneUser(user: any): any {
    if (!user || typeof user !== 'object') {
      return user;
    }
    try {
      return JSON.parse(JSON.stringify(user));
    } catch {
      return user;
    }
  }

  /**
   * Apply a /users/me payload and reveal the page. WooCommerce customer
   * details are merged afterwards and never gate `loading`.
   */
  private consumeUserPayload(data: any, fromServer = false): void {
    if (this.destroyed || !data) {
      this.loading = false;
      if (fromServer) {
        this.billingUserFromServer = true;
        this.finishBillingProfileCheck();
      }
      return;
    }
    try {
      this.loginUserInformation = data;
      const meta = (data && data.meta && typeof data.meta === 'object' && !Array.isArray(data.meta))
        ? data.meta
        : {};
      this.quota_status = meta.quota_status;
      this.name = data?.name;
      this.email = data?.email;
      this.phone_number = meta.phone_number;
      this.expire_date = meta.expires_at;
      this.today_date = meta.today_date;

      if (!data.meta || typeof data.meta !== 'object' || Array.isArray(data.meta)) {
        data.meta = meta;
      }

      this.applyBillingLocationFromUser(data);
      this.finalizeUserDataProcessing(data);
      // A users/me body can still say India after the customer record was
      // updated to the US. The address saved in this visit wins, and prices
      // are rebuilt for that country.
      this.reapplySavedBillingAddress();
      if (fromServer) {
        this.billingUserFromServer = true;
        this.markRailUserSectionsReady();
        this.resolveBillingProfileBanner(data);
      }
    } catch (err) {
      console.error('getUser: user processing failed; clearing loading.', err);
      this.loading = false;
      this.markRailUserSectionsReady();
      this.cdr.markForCheck();
    }
  }

  /**
   * The stored user often has no address. Do not show "Complete your billing
   * information" until the fresh company record has been read.
   */
  private resolveBillingProfileBanner(data: any): void {
    this.mergeWooCustomerInBackground(data);
  }

  private finishBillingProfileCheck(): void {
    this.needsBillingProfileFlag = !this.hasSavedBillingProfile();
    this.billingProfileChecked = true;
    this.cdr.markForCheck();
    this.applyBillingIntent();
  }

  /** Fill address gaps from Woo without putting the page back on the skeleton. */
  private mergeWooCustomerInBackground(data: any): void {
    const customerId = data?.id;
    if (!customerId) {
      this.finishBillingProfileCheck();
      return;
    }
    this.woocommerceService
      .getCustomerDetails(customerId)
      .pipe(
        timeout(8000),
        catchError((error) => {
          console.error('Error fetching customer billing data from WooCommerce:', error);
          return of(null);
        })
      )
      .subscribe((customerDetails: any) => {
        if (this.destroyed) {
          return;
        }
        if (!customerDetails?.billing) {
          this.finishBillingProfileCheck();
          return;
        }
        try {
          const billing = customerDetails.billing;
          if (billing.phone && !this.phone_number) {
            this.phone_number = billing.phone;
          }
          if (!this.billing_country && billing.country) {
            this.billing_country = billing.country;
          }
          if (!this.billing_state && billing.state) {
            this.billing_state = billing.state;
          }
          if (!data.billing_address) {
            data.billing_address = {};
          }
          data.billing_address.country = data.billing_address.country || billing.country || '';
          data.billing_address.state = data.billing_address.state || billing.state || '';
          data.billing_address.address_1 =
            data.billing_address.address_1 || billing.address_1 || '';
          data.billing_address.address_2 =
            data.billing_address.address_2 || billing.address_2 || '';
          data.billing_address.city = data.billing_address.city || billing.city || '';
          data.billing_address.postcode =
            data.billing_address.postcode || billing.postcode || '';
          data.billing_address.phone =
            data.billing_address.phone || billing.phone || this.phone_number || '';
          this.reapplySavedBillingAddress();
          this.finishBillingProfileCheck();
        } catch (err) {
          console.error('getUser: billing merge failed, continuing.', err);
          this.finishBillingProfileCheck();
        }
      });
  }

  finalizeUserDataProcessing(data: any) {
    console.info('[Billing] finalizeUserDataProcessing entered — flipping loading=false', {
      hasMeta: !!data?.meta,
      quotaStatus: data?.meta?.quota_status,
      hasPhone: !!(data?.meta?.phone_number),
      billingCountry: data?.meta?.billing_country || data?.meta?.country || '(empty)',
    });
    this.loading = false;
    // Do not call detectChanges() here. Browser Back and the HTTP cache both
    // deliver the user synchronously inside ngOnInit, and detectChanges() in
    // that turn throws and leaves the skeleton on screen. markForCheck is
    // enough; the router turn finishes and Angular paints loading=false.
    this.cdr.markForCheck();
    let roleArr = data.role || [];

    this.determinePaymentParameters();
    this.applySavedTaxNumber(data?.meta);

    if (data) {
      this.applyPlanDisplayFromMeta(data.meta);
      if (this.plan_data?.length) {
        this.applySeatProductSelectionFromCatalog();
      }
      this.quota_status = data.meta.quota_status;
      this.name = data.name;
      this.email = data.email;
      this.phone_number = data.meta.phone_number;
      this.expire_date = data.meta.expires_at;
      this.today_date = data.meta.today_date;
      this.rzp_next_renewal_date = data.meta.rzp_next_renewal;
      this.razorpaySubscriptionId = String(data.meta.razorpay_subscription_id || '');
      this.nextChargeAmount = this.parseOptionalNumber(data.meta.next_charge_amount);
      this.nextChargeCurrency = data.meta.next_charge_currency || null;
      this.nextChargeDate = data.meta.next_charge_date || null;
      this.loadBillingAddOns(data);

      if (data.meta && data.meta.tax_no) {
        this.txtGst = data.meta.tax_no;
        this.isGST = true;
        this.isGSTVerified = true;
      }

      // Set auto-renew to false by default, only set to true if explicitly enabled
      // Checkout writes is_auto_renew. is_auto_renew_status may still be "0".
      this.auto_renew = data.meta.auto_renew === true ? true : false;
      this.subscription_status = data.meta.subscription_status || 'default'; // Fallback to 'default' if undefined
      this.is_auto_renew_status = readAutoRenewEnabled(data.meta);
      this.grace_period = data.meta.grace_period || null;
      this.adv_payment_days = data.meta.adv_payment_days || null;
      this.trial_grace_period = data.meta.trial_grace_period || null;

      if (this.plan_data && this.plan_data.length > 0) {
        this.subscription_status = data.meta.subscription_status || '';
        this.is_auto_renew_status = readAutoRenewEnabled(data.meta);
        this.grace_period = data.meta.grace !== undefined ? Number(data.meta.grace) : null;
        this.adv_payment_days = data.meta.adv_pay !== undefined ? Number(data.meta.adv_pay) : null;
        this.trial_grace_period = data.meta.trial_grace !== undefined ? Number(data.meta.trial_grace) : null;
        if (data.meta.expires_at) {
          this.expire_date = data.meta.expires_at;
        }
      } else {
        this.subscription_status = data.subscription_status || '';
        this.is_auto_renew_status = readAutoRenewEnabled(data.meta);
        this.grace_period = data.grace !== undefined ? Number(data.grace) : null;
        this.adv_payment_days = data.adv_pay !== undefined ? Number(data.adv_pay) : null;
        this.trial_grace_period = data.trial_grace !== undefined ? Number(data.trial_grace) : null;
        if (data.expires_at) {
          this.expire_date = data.expires_at;
        }
      }

      // Trial access is not a paid subscription. A missing gateway status must
      // not be shown as Active (SUSEE-1571).
      const quotaLabel = String(data.meta?.quota_status || '').toLowerCase();
      const gatewayStatus = (this.subscription_status || '').toLowerCase();
      const gatewayStatusMissing = !gatewayStatus || gatewayStatus === 'default';

      if (quotaLabel === 'trial' && gatewayStatusMissing) {
        this.displaySubscriptionStatusText = 'None';
      } else if (gatewayStatus === 'cancelled') {
        this.displaySubscriptionStatusText = 'Cancelled';
      } else if (gatewayStatus === 'active') {
        this.displaySubscriptionStatusText = 'Active';
      } else if (gatewayStatus === 'pending') {
        this.displaySubscriptionStatusText = 'Pending';
      } else if (gatewayStatus === 'paused') {
        this.displaySubscriptionStatusText = 'Paused';
      } else if (gatewayStatus === 'halted') {
        this.displaySubscriptionStatusText = 'Halted';
      } else if (gatewayStatus === 'completed') {
        this.displaySubscriptionStatusText = 'Completed';
      } else if (gatewayStatusMissing && quotaLabel === 'active') {
        this.displaySubscriptionStatusText = 'Active';
      } else if (this.subscription_status && !gatewayStatusMissing) {
        this.displaySubscriptionStatusText =
          this.subscription_status.charAt(0).toUpperCase() + this.subscription_status.slice(1);
      } else {
        this.displaySubscriptionStatusText = 'None';
      }

      // Set display text for auto-renewal
      this.displayAutoRenewText = this.is_auto_renew_status ? 'Yes' : 'No';

      if (this.displaySubscriptionStatusText === 'None' && quotaLabel === 'trial') {
        this.next_renewal_label = '';
        this.renewal_notification_text = 'No paid subscription yet. Choose a plan before the trial ends.';
      } else if (this.is_auto_renew_status) {
        this.next_renewal_label = 'Next renewal on';
        this.renewal_notification_text = 'Your subscription will automatically renew.';
      } else {
        this.next_renewal_label = 'Active until';
        this.renewal_notification_text = 'We will send you a notification upon Subscription expiration.';
      }

      if (Array.isArray(this.plan_data) && this.plan_data.length) {
        this.applySeatProductSelectionFromCatalog();
      }
      if (this.billing_country !== 'IN') {
        if (this.monthly_usd_price === 0 && this.monthly_price !== 0) {
          this.monthly_usd_price = this.monthly_price;
        }
        if (this.yearly_usd_price === 0 && this.yearly_price !== 0) {
          this.yearly_usd_price = this.yearly_price;
        }
      }

      let adv_pay = data.meta.adv_pay ? Number(data.meta.adv_pay) : 0;
      let checkDayDiff = this.expiringDate(this.expire_date, this.today_date)

      let user_role = roleArr.length ? roleArr[0] == 'employee' ? roleArr[1] : roleArr[0] : '';
      let availableUser = data.meta.quota_remaining == 'false' || data.meta.quota_remaining == false ? 1 : Number(data.meta.quota_allowed) - Number(data.meta.quota_remaining);
      availableUser = availableUser <= 0 ? 1 : availableUser;

      this.user = Number(data.meta.quota_allowed) > 0 ? Number(data.meta.quota_allowed) : 1;
      this.quota_allowed = Number(data.meta.quota_allowed) > 0 ? Number(data.meta.quota_allowed) : 1;
      this.min = Number(availableUser);

      this.totalUserCurrent = data.meta.quota_allowed < 0 ? 0 : data.meta.quota_allowed;
      this.availableUser = data.meta.quota_remaining == 'false' || data.meta.quota_remaining == false ? 0 : data.meta.quota_remaining;
      this.availableUser = this.availableUser < 0 ? 0 : this.availableUser;
      this.useUser = (data.meta.quota_allowed - this.availableUser) < 0 ? 0 : (data.meta.quota_allowed - this.availableUser)

      let quota_Status = data.meta.quota_status;
      if (quota_Status == 'active' || quota_Status == 'Active' || quota_Status == 'trial' || quota_Status == 'Trial') {
        this.quotaStatus = 'active';
        if (data.meta.expires_at) {
          let day_left = this.getRemainingDate(data.meta.expires_at)
          if (day_left < 0) {
            this.quotaStatus = 'expired';
          }
        }
      }
      if (quota_Status == 'trial-expired' || quota_Status == 'Trial-expired' || quota_Status == 'expired' || quota_Status == 'Expired') {
        this.quotaStatus = 'expired';
      }

      if (data.meta.expires_at) {
        this.quota_expired_date = this.formattedDate(data.meta.expires_at);
      }

      if (data.meta.expires_at && !this.expire_date) {
        this.expire_date = data.meta.expires_at;
      }

      if (data.meta.quota_status == 'active') {
        const subStatus = (data.meta.subscription_status || '').toLowerCase();
        console.log("checkDayDiff", checkDayDiff, adv_pay)
        if (subStatus !== 'active' && checkDayDiff <= adv_pay) {
          this.isAdvancePayment = true;
        }
        if (!this.pendingBillingIntent || this.pendingBillingIntent === 'upgrade') {
          this.seatCheckoutExpanded = false;
        }
        if (this.isToggle == false && !this.isAdvancePayment) {
          this.strPlan = 'Increase seat limit';
          this.selected_plan_type = 'addon';
          if (!this.seatCheckoutExpanded) {
            this.user = 1;
            this.min = 1;
          }
        } else if (this.isAdvancePayment) {
          this.strPlan = `Pay`
          this.selected_plan_type = 'main';
        }
        this.selectPlanTypeAction(resolveBillingPeriodSlug(data.meta));
      } else {
        this.selected_plan_type = 'main';
        this.strPlan = 'Buy now';
        this.syncCheckoutPlanCodeFromContext();
        const checkoutTierName = planCodeDisplayName(this.checkoutPlanCode);
        this.seatCheckoutPanelTitle = checkoutTierName
          ? `Set up ${checkoutTierName} seat subscription`
          : 'Set up seat subscription';
        this.seatCheckoutExpanded = true;
      }

      // Populate the selected-cadence price/total even before (or without) a
      // billing profile — international pricing is the default in that case.
      this.calculateTotalAmount();

      console.log("roleArr", roleArr)

      this.isAdmin = hasCompanyRole(data);
      if (this.isAdmin) {
        if (this.recentInvoicesLoading && !this.recentInvoices.length) {
          this.loadRecentInvoices();
        }
        this.loadScreencastQuota(data);
      } else {
        this.recentInvoicesLoading = false;
      }

      this.scheduleBillingQuoteRefresh();
      if (!this.planTiers.length) {
        this.loadPlanCatalog();
      }
      this.applyBillingIntent();

      this.loading = false;
      this.maybeTrackBillingView();
    }
  }

  private loadBillingAddOns(user: any): void {
    const companyId = this.resolveCompanyId(user);
    if (!companyId) {
      this.addOnsLoading = false;
      this.cdr.markForCheck();
      return;
    }

    this.addOnsLoading = true;
    this.cdr.markForCheck();

    // Independent 15 s wait: a hung add-ons endpoint shows a local message
    // and never blocks the rest of the page.
    this.settingsEntitlementsService
      .getCompanyAddOnEntitlements(companyId)
      .pipe(
        timeout(15000),
        catchError((err) => {
          console.warn('[Billing] company add-ons load failed/timed out.', err);
          return of({ assigned_addons: [] as any[], addons: [] as any[] });
        })
      )
      .subscribe({
        next: (response: any) => {
          this.companyAddOns = response?.assigned_addons ?? response?.addons ?? [];
          this.addOnStateMessage = '';
          this.addOnsLoading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.addOnStateMessage = 'Unable to load applicable add-ons.';
          this.addOnsLoading = false;
          this.cdr.markForCheck();
        },
      });

    this._projectService
      .getUserList(0, 0, false)
      .pipe(
        timeout(15000),
        catchError(() => of([]))
      )
      .subscribe((employees: any) => {
        const list = Array.isArray(employees) ? employees : employees?.data || [];
        this.addOnEmployeeNamesById = new Map(
          list.map((employee: any) => [
            Number(employee.id),
            employee.name || employee.email || `User #${employee.id}`,
          ])
        );
        // WP get_company_user_count includes company admin via ss_company_id; list may not.
        const ids = new Set(list.map((e: any) => Number(e.id)).filter((id: number) => id > 0));
        let headcount = ids.size;
        if (this.billingCompanyId > 0 && !ids.has(this.billingCompanyId)) {
          headcount += 1;
        }
        this.activeEmployeeCount = headcount;
        this.applyHeadcountSeatFloorIfNeeded();
      });
  }

  /** Seat qty/min must cover people on the account (not just old quota_allowed). */
  private seatFloorFromHeadcount(): number {
    return Math.max(
      1,
      Number(this.activeEmployeeCount) || 0,
      this.addOnEmployeeNamesById?.size || 0,
      Number(this.useUser) || 0
    );
  }

  private applyHeadcountSeatFloorIfNeeded(): void {
    if (!this.seatCheckoutExpanded) {
      return;
    }
    if (this.checkoutMode !== 'setup' && this.checkoutMode !== 'renew') {
      return;
    }
    const floor = this.seatFloorFromHeadcount();
    this.min = Math.max(Number(this.min) || 1, floor);
    if (Number(this.user) < floor) {
      this.user = floor;
      this.calculateTotalAmount();
      this.retryBillingQuote();
    }
  }

  private resolveCompanyId(user: any): number {
    const rawCompanyId =
      user?.company_id
      ?? user?.companyId
      ?? user?.meta?.company_id
      ?? user?.meta?.companyId
      ?? user?.id;
    const companyId = Number(rawCompanyId);
    const resolved = Number.isFinite(companyId) && companyId > 0 ? companyId : 0;
    if (resolved > 0) {
      this.billingCompanyId = resolved;
    }
    return resolved;
  }

  addOnsForBillingView(): CompanyAddOnEntitlement[] {
    return this.companyAddOns.filter((addon) => addon.enabled);
  }

  addOnAssignmentLabel(addon: CompanyAddOnEntitlement): string {
    if (addon.assignment_mode === 'all_users') {
      return 'All users';
    }
    if (addon.assignment_mode === 'specific_users') {
      return 'Specific users';
    }
    return 'Company-wide';
  }

  addOnSpecificUserNames(addon: CompanyAddOnEntitlement): string {
    if (addon.assignment_mode !== 'specific_users') {
      return '';
    }

    const names = (addon.user_ids ?? []).map((id) =>
      this.addOnEmployeeNamesById.get(Number(id)) || `User #${id}`
    );

    return names.length ? names.join(', ') : 'No users selected';
  }

  addOnConfigLabel(addon: CompanyAddOnEntitlement): string {
    if (addon.config?.['unlimited']) {
      return 'Unlimited';
    }
    if (addon.config?.['limit_minutes']) {
      return `${addon.config['limit_minutes']} minutes`;
    }
    return '';
  }

  async getPlanDetail(): Promise<any> {
    return new Promise((resolve) => {
      // IMPORTANT: do NOT touch this.loading here. getUser() owns the main
      // loading flag. Plan details load in parallel and shouldn't flip the
      // skeleton back on after getUser has already finished.
      this.seatPricesLoading = true;
      const settle = () => {
        this.seatPricesLoading = false;
        this.cdr.markForCheck();
        this.applyBillingIntent();
        resolve(true);
      };
      this._projectService
        .checkUserPlan()
        .pipe(
          timeout(20000),
          catchError(() => of([]))
        )
        .subscribe({
          next: (data: any) => {
            try {
              this.plan_data = Array.isArray(data) ? data : [];
              if (this.plan_data.length) {
                this.applySeatProductSelectionFromCatalog();
                this.calculateTotalAmount();
              }
            } catch (err) {
              console.error('getPlanDetail: processing failed, continuing.', err);
              this.plan_data = [];
            } finally {
              settle();
            }
          },
          error: (err) => {
            console.error('getPlanDetail: subscription errored.', err);
            this.plan_data = [];
            settle();
          },
        });
    });
  }

  /**
   * Seat count used to pick a band SKU.
   * Add-seats must use seats already on the subscription (quota), not the add qty —
   * adding 1 to a 42-seat plan stays on 30+, not the 1–4 band (SUSEE-1548).
   */
  private seatsForBandProduct(): number {
    if (this.selected_plan_type === 'addon') {
      return Math.max(
        1,
        Number(this.quota_allowed) || 0,
        Number(this.totalUserCurrent) || 0,
        Number(this.user) || 1
      );
    }
    return Math.max(1, Number(this.user) || Number(this.quota_allowed) || 1);
  }

  /** Resolve Monthly/Quarterly/Yearly WC products for current tier, seats, and country (SUSEE-1546). */
  private applySeatProductSelectionFromCatalog(): void {
    const products = (this.plan_data || []) as WcSeatProduct[];
    const currency = resolveWcCurrencyScope(this.billing_country);
    const planCodeForCheckout = this.checkoutPlanCode || this.defaultCheckoutPlanCode();
    const seats = this.seatsForBandProduct();

    if (this.selected_plan_type !== 'addon' && seats <= 4 && this.plan_type !== 'Yearly') {
      this.plan_type = 'Yearly';
      this.monthlyBackground = '';
      this.quarterlyBackground = '';
      this.yearlyBackground = 'monthly-btn-bg-color';
    }

    // Mid-term add-seats stay on the live subscription cadence.
    if (this.selected_plan_type === 'addon' && this.subscriptionBillingPeriod) {
      this.syncSeatCheckoutBillingPeriod();
    }

    const monthly = findBundledSeatProduct(
      products,
      planCodeForCheckout,
      'monthly',
      currency,
      seats
    );
    const quarterly = findBundledSeatProduct(
      products,
      planCodeForCheckout,
      'quarterly',
      currency,
      seats
    );
    const yearly = findBundledSeatProduct(
      products,
      planCodeForCheckout,
      'yearly',
      currency,
      seats
    );

    if (monthly) {
      this.monthly_price = readProductInrPrice(monthly);
      this.monthly_usd_price = readProductUsdPrice(monthly, this.billing_country);
    }
    if (quarterly) {
      this.quarterly_price = readProductInrPrice(quarterly);
      this.quarterly_usd_price = readProductUsdPrice(quarterly, this.billing_country);
    } else {
      this.quarterly_price = 0;
      this.quarterly_usd_price = 0;
    }
    if (yearly) {
      this.yearly_price = readProductInrPrice(yearly);
      this.yearly_usd_price = readProductUsdPrice(yearly, this.billing_country);
    }

    const periodSlug = billingPeriodLabelToSlug(this.plan_type);
    const semiannual =
      periodSlug === 'semiannual'
        ? findBundledSeatProduct(products, planCodeForCheckout, 'semiannual', currency, seats)
        : null;
    const selected =
      periodSlug === 'yearly'
        ? yearly
        : periodSlug === 'quarterly'
          ? quarterly
          : periodSlug === 'semiannual'
            ? semiannual
            : monthly;
    this.plan_id = 0;
    this.selected_price = 0;
    this.selected_usd_price = 0;
    if (selected) {
      this.plan_id = selected.id;
      this.selected_price = readProductInrPrice(selected);
      this.selected_usd_price = readProductUsdPrice(selected, this.billing_country);
      this.display_unit_price_inr = Math.round(
        effectiveMonthlyFromPrepaid(this.selected_price, periodSlug)
      );
      this.display_unit_price_usd =
        Math.round(effectiveMonthlyFromPrepaid(this.selected_usd_price, periodSlug) * 100) / 100;
      const addon = selected.ss_per_user_price;
      if (addon) {
        this.addon_price_inr = Number(addon.inr) || 0;
        this.addon_price_usd = Number(addon.usd) || 0;
        this.addon_days_remaining = Number(addon.days_remaining) || 0;
      }
    }
  }

  isMicroTeamSeats(): boolean {
    return Math.max(1, Number(this.user) || 1) <= 4;
  }

  billingCadenceDisabledReason(): string | null {
    if (!this.canChangeSeatBillingCadence()) {
      return 'Billing period is fixed until your current seat term ends';
    }
    if (this.isMicroTeamSeats()) {
      return 'Teams of 1–4: annual only.';
    }
    return null;
  }

  quarterlySaveChip(): string {
    const opt = this.checkoutPeriodOptions().find((o) => o.period === 'quarterly');
    return opt?.savingsPercent ? `${opt.savingsPercent}% off` : '';
  }

  /** Shown to Monthly and Quarterly customers when yearly is cheaper. Text only. */
  yearlySwitchHint(): string {
    const period = (this.subscriptionBillingPeriod || '').toLowerCase();
    if (period === 'yearly' || period === 'annual') {
      return '';
    }
    const seats = Math.max(1, Number(this.quota_allowed) || 1);
    const opt = periodOptions(
      (this.plan_data || []) as WcSeatProduct[],
      this.currentPlanCode,
      seats,
      resolveWcCurrencyScope(this.billing_country),
      this.billing_country
    ).find((o) => o.period === 'yearly');
    if (!opt?.available || !opt.savingsPercent) {
      return '';
    }
    if (opt.savingsVsMonthlyPerYear > 0) {
      return `Switch to yearly billing at renewal and save ${this.priceText(Math.round(opt.savingsVsMonthlyPerYear))} a year (${opt.savingsPercent}%).`;
    }
    return `Yearly billing is ${opt.savingsPercent}% cheaper than monthly.`;
  }

  yearlySaveChip(): string {
    const opt = this.checkoutPeriodOptions().find((o) => o.period === 'yearly');
    return opt?.savingsPercent ? `Save ${opt.savingsPercent}%` : '';
  }

  billingState(): BillingHeroState {
    if (!this.isAdmin) {
      return 'non_admin';
    }
    // Never route renew/expired to WhatsApp — customers need Renew/Reactivate → pay.
    // Add-on re-attachment after pay can still be handled by support if needed.
    if (this.isTrialCompany()) {
      return 'trial';
    }
    if ((this.quotaStatus || '').toLowerCase() === 'expired') {
      return 'expired';
    }
    if (this.isAdvancePayment) {
      return 'renew_window';
    }
    return 'active';
  }

  /**
   * Header countdown uses the same date as the "Renews" / "Valid until" label.
   * Auto-renew on counts to Razorpay's next charge, not expires_at.
   */
  heroDaysLeft(): number | null {
    if (!this.today_date) {
      return null;
    }
    const target = this.billingHeaderDate().date ?? parseLocalCalendarDate(this.expire_date);
    if (!target) {
      return null;
    }
    const days = calendarDaysBetween(this.today_date, target);
    if (days == null) {
      return null;
    }
    return Math.max(0, days);
  }

  /** Date after "Renews" or "Valid until" on the billing hero. */
  heroValidUntil(): string {
    const resolved = this.billingHeaderDate();
    if (resolved.date) {
      return this.datePipe.transform(resolved.date, 'MMM dd, yyyy') || this.quota_expired_date || '';
    }
    return this.quota_expired_date || '';
  }

  /**
   * Same flag the hero uses for "Renews" vs "Valid until": a saved gateway
   * status plus auto-renew on. Checkout's own toggle is `auto_renew`.
   */
  private billingHeaderAutoRenew(): boolean {
    return !!this.subscription_status && this.is_auto_renew_status === true;
  }

  private billingHeaderDate() {
    return resolveBillingHeaderDate({
      autoRenew: this.billingHeaderAutoRenew(),
      rzpNextRenewalDate: this.rzp_next_renewal_date,
      expiresAt: this.expire_date,
    });
  }

  planCodeLabel(code: string): string {
    return planCodeDisplayName(code) || code;
  }

  supportPhoneDisplay(): string {
    return (environment as any).support?.phone || '+91 9016310001';
  }

  supportPhoneHref(): string {
    return this.supportPhoneDisplay().replace(/\s+/g, '');
  }

  supportWhatsAppUrl(context: string): string {
    const wa = (environment as any).support?.whatsapp || '916354719703';
    const text = encodeURIComponent(
      `Hi, I need help with SuperSee billing (${context}).`
    );
    return `https://api.whatsapp.com/send?phone=${wa}&text=${text}`;
  }

  /**
   * Add seats stays hidden until country, seat prices, and the billing
   * calls have all finished. While they are running the hero shows a spinner;
   * if they finish without that data, it shows Refresh.
   */
  heroPrimaryPending(): boolean {
    return (
      !this.billingUserFromServer ||
      !this.billingProfileChecked ||
      this.seatPricesLoading ||
      this.planCatalogLoading
    );
  }

  heroPrimaryReady(): boolean {
    if (this.heroPrimaryPending()) {
      return false;
    }
    if (!this.billing_country || !this.hasSavedBillingProfile()) {
      return false;
    }
    if (!Array.isArray(this.plan_data) || this.plan_data.length === 0) {
      return false;
    }
    if (this.billingState() === 'trial' || this.pricingMode === 'custom') {
      return true;
    }
    return !!this.currentSeatPriceLine();
  }

  /** Profile is saved, but prices or the rest of the billing payload did not come back. */
  heroShowRefresh(): boolean {
    return !this.heroPrimaryPending() && !this.heroPrimaryReady() && this.hasSavedBillingProfile();
  }

  /** Reload country, prices, and the plan catalog. Add seats stays hidden until they land. */
  refreshBillingData(): void {
    this.billingUserFromServer = false;
    this.billingProfileChecked = false;
    this.resetRailSectionLoaders();
    this.getUser();
    this.getPlanDetail();
    this.loadPlanCatalog();
    this.cdr.markForCheck();
  }

  onHeroPrimary(): void {
    if (!this.heroPrimaryReady()) {
      this.refreshBillingData();
      return;
    }
    const state = this.billingState();
    this.billingAnalytics.track('billing_primary_cta_clicked', { state, action: 'primary' });
    if (state === 'expired') {
      // Full reactivation checkout (pay for a new term) — not "renew early".
      this.expandSeatCheckout('setup');
      return;
    }
    if (state === 'renew_window' || state === 'addon_locked') {
      this.expandSeatCheckout('renew');
      return;
    }
    if (state === 'trial') {
      this.expandSeatCheckout('add');
      return;
    }
    // Near-full (0–1 free seats): prefill +5; otherwise open add-seats at qty 1.
    const freeSeats = Math.max(0, Number(this.quota_allowed || 0) - Number(this.useUser || 0));
    this.expandSeatCheckout('add', freeSeats <= 1 ? 5 : 1);
  }

  /**
   * Same calendar day as the subscription card's "Next renewal".
   * Prefer Razorpay's next charge. Fall back to next_charge_date.
   * Date-only values stay on that local day.
   */
  subscriptionRenewalDateText(): string {
    const date = parseLocalCalendarDate(this.rzp_next_renewal_date || this.nextChargeDate);
    if (!date) {
      return '';
    }
    return this.datePipe.transform(date, 'MMM dd, yyyy') || '';
  }

  /** Hero next-charge line from users/me; empty when amount unknown — never invent ₹. */
  nextChargeHeroLine(): string {
    if (this.pricingMode === 'custom') {
      return '';
    }
    const when = this.subscriptionRenewalDateText();
    if (this.nextChargeAmount == null || !when) {
      return '';
    }
    // Follow the saved auto-renew flag. A Razorpay id alone is not "on":
    // the subscription card can say No while the id is still present.
    const renewLabel = this.is_auto_renew_status ? 'Auto-renew on' : 'Renewal price';
    const amount = this.subscriptionNextChargeText();
    return `${amount} on ${when} · ${renewLabel}`;
  }

  /**
   * Subscription "Next charge". INR shows the API renewal total once, as GST-inclusive.
   * Renewal date and status are rendered separately and are not part of this string.
   */
  subscriptionNextChargeText(): string {
    if (this.nextChargeAmount == null) {
      return '';
    }
    return formatSubscriptionNextCharge(this.money(this.nextChargeAmount), this.billing_country);
  }

  private parseOptionalNumber(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  onHeroSecondary(): void {
    const state = this.billingState();
    this.billingAnalytics.track('billing_primary_cta_clicked', { state, action: 'secondary' });
    if (state === 'trial') {
      this.scrollToProductTiers();
      return;
    }
    this.upgradeToRecommendedTier();
  }

  checkoutPeriodOptions(): PeriodOption[] {
    const products = (this.plan_data || []) as WcSeatProduct[];
    const currency = resolveWcCurrencyScope(this.billing_country);
    const planCode = this.checkoutPlanCode || this.defaultCheckoutPlanCode();
    const seats = Math.max(1, Number(this.user) || 1);
    return periodOptions(products, planCode, seats, currency, this.billing_country);
  }

  /** Unavailable periods have no price, so they are left out instead of shown as blank tiles. */
  availablePeriodOptions(): PeriodOption[] {
    const seats = Math.max(1, Number(this.user) || 1);
    const plan = this.checkoutPlanCode || this.defaultCheckoutPlanCode();
    const country = this.billing_country || '';
    const products = this.plan_data;
    const hit = this.periodOptionsCache;
    if (
      hit &&
      hit.seats === seats &&
      hit.plan === plan &&
      hit.country === country &&
      hit.products === products
    ) {
      return hit.options;
    }
    const options = this.checkoutPeriodOptions().filter((o) => o.available);
    this.periodOptionsCache = { seats, plan, country, products, options };
    return options;
  }

  isPeriodSelected(period: BillingPeriodSlug): boolean {
    return billingPeriodLabelToSlug(this.plan_type) === period;
  }

  periodCardTitle(period: BillingPeriodSlug): string {
    return periodDisplayName(period);
  }

  /** Noun after “every …” on period cards: “month”, “3 months”, “6 months”, “year”. */
  periodTermText(period: BillingPeriodSlug): string {
    if (period === 'quarterly') {
      return '3 months';
    }
    if (period === 'semiannual') {
      return '6 months';
    }
    if (period === 'yearly') {
      return 'year';
    }
    return 'month';
  }

  /** Auto-renew helper: “every month” / “every 3 months” / “every 6 months” / “every year”. */
  autoRenewEveryPhrase(): string {
    const slug = billingPeriodLabelToSlug(this.plan_type);
    if (slug === 'quarterly') {
      return 'every 3 months';
    }
    if (slug === 'semiannual') {
      return 'every 6 months';
    }
    if (slug === 'yearly') {
      return 'every year';
    }
    return 'every month';
  }

  /** Unambiguous day for checkout copy, e.g. “28 Oct 2027”. */
  formatDayMonthYear(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }
    const parsed = parseLocalCalendarDate(value);
    if (!parsed) {
      return '';
    }
    return this.datePipe.transform(parsed, 'd MMM yyyy') || '';
  }

  /**
   * Start of the term this checkout purchases.
   * Auto-renew on always starts today, including an early renewal, because
   * the Razorpay subscription is created without start_at.
   * Auto-renew off keeps the current expiry when that date is still ahead.
   */
  private checkoutTermStartDate(): Date {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (this.auto_renew) {
      return today;
    }
    const renewingEarly =
      this.checkoutMode === 'renew' &&
      this.billingState() !== 'expired' &&
      !!this.expire_date;
    if (renewingEarly) {
      const expiry = parseLocalCalendarDate(this.expire_date);
      if (expiry && expiry.getTime() > today.getTime()) {
        return expiry;
      }
    }
    return today;
  }

  /** End of the term this checkout purchases. */
  private checkoutTermEndDate(): Date | null {
    return getTermEndDate(this.checkoutTermStartDate(), this.plan_type, !!this.auto_renew);
  }

  /**
   * What the customer gets for today's total: coverage end date.
   * Auto-renew on → “Renews on …”; off → “Valid until …”.
   */
  checkoutCoverageLine(): string | null {
    if (this.selected_plan_type === 'addon') {
      return null;
    }
    const end = this.checkoutTermEndDate();
    if (!end) {
      return null;
    }
    const when = this.formatDayMonthYear(end);
    if (!when) {
      return null;
    }
    return this.auto_renew ? `Renews on ${when}` : `Valid until ${when}`;
  }

  selectPeriodOption(period: BillingPeriodSlug): void {
    if (!this.canChangeSeatBillingCadence()) {
      return;
    }
    if (this.isMicroTeamSeats() && period !== 'yearly') {
      return;
    }
    this.selectPlanTypeAction(period);
    this.comparePeriod = period;
    this.billingAnalytics.track('period_selected', {
      period,
      seats: this.user,
    });
  }

  /** Period shown in Compare plans column headers. */
  comparePeriodSlug(): BillingPeriodSlug {
    // 1–4 seat band is annual-only; never show monthly/quarterly SKUs there (SUSEE-1550).
    if (this.compareSeatCount() <= 4) {
      return 'yearly';
    }
    if (this.comparePeriod) {
      return this.comparePeriod;
    }
    if (this.seatCheckoutExpanded && this.selected_plan_type !== 'addon') {
      return billingPeriodLabelToSlug(this.plan_type);
    }
    return billingPeriodLabelToSlug(
      this.subscriptionBillingPeriod || this.plan_type || 'Yearly'
    );
  }

  selectComparePeriod(period: BillingPeriodSlug): void {
    this.comparePeriod = period;
    // Keep checkout in sync when the customer is already in a reactivation / setup flow.
    if (
      this.seatCheckoutExpanded &&
      this.selected_plan_type !== 'addon' &&
      this.canChangeSeatBillingCadence() &&
      !(this.isMicroTeamSeats() && period !== 'yearly')
    ) {
      this.selectPlanTypeAction(period);
    }
    this.billingAnalytics.track('period_selected', {
      period,
      source: 'compare',
      seats: this.compareSeatCount(),
    });
  }

  /**
   * Seats used for Compare price notes.
   * Prefer the open checkout stepper so prices track 1–4 vs 5–29 bands (SUSEE-1550).
   * Do not floor at 5 — that hid the annual 1–4 rates.
   */
  private compareSeatCount(): number {
    if (this.seatCheckoutExpanded) {
      const checkoutSeats = Math.trunc(Number(this.user) || 0);
      if (checkoutSeats > 0) {
        return checkoutSeats;
      }
    }
    const fromContext = Math.max(
      Number(this.activeEmployeeCount) || 0,
      Number(this.quota_allowed) || 0
    );
    return Math.max(1, fromContext || 5);
  }

  cadenceLockMessage(): string | null {
    if (this.selected_plan_type === 'addon') {
      const period = this.subscriptionBillingPeriod || this.plan_type || 'Monthly';
      const until = this.expire_date ? this.formattedDate(this.expire_date) : '';
      return until
        ? `Extra seats follow your current ${period} term until ${until}.`
        : `Extra seats follow your current ${period} term.`;
    }
    if (this.isMicroTeamSeats()) {
      return 'Teams of 1 to 4 seats are billed annually.';
    }
    return null;
  }

  bandHintLine(): string | null {
    if (this.selected_plan_type === 'addon') {
      return null;
    }
    const products = (this.plan_data || []) as WcSeatProduct[];
    const currency = resolveWcCurrencyScope(this.billing_country);
    const planCode = this.checkoutPlanCode || this.defaultCheckoutPlanCode();
    const period = billingPeriodLabelToSlug(this.plan_type);
    const hint = nextBandHint(
      products,
      planCode,
      period,
      Math.max(1, Number(this.user) || 1),
      currency,
      this.billing_country
    );
    if (!hint) {
      return null;
    }
    const prefix = this.billing_country === 'IN' ? '₹' : '$';
    return `Add ${hint.seatsNeeded} more seat${hint.seatsNeeded !== 1 ? 's' : ''} to get ${prefix}${hint.perSeatMonthly}/seat/month.`;
  }

  /** Seats after this purchase (existing plus the ones being added). */
  addSeatsTotal(): number {
    return Number(this.quota_allowed || 0) + Math.max(0, Math.trunc(Number(this.user) || 0));
  }

  /** Amount with the currency symbol and Indian digit grouping where it applies. */
  money(value: number | string | null | undefined): string {
    const n = Number(value) || 0;
    const isInr = this.billing_country === 'IN';
    const text = new Intl.NumberFormat(isInr ? 'en-IN' : 'en-US', {
      minimumFractionDigits: n % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(n);
    return `${isInr ? '₹' : '$'}${text}`;
  }

  /** The number that matters most: what the next renewal will be once these seats are added. */
  addonRenewalLine(): string | null {
    if (this.selected_plan_type !== 'addon' || !this.expire_date) {
      return null;
    }
    const isInr = this.billing_country === 'IN';
    const perSeat = Number(isInr ? this.selected_price : this.selected_usd_price) || 0;
    if (!perSeat) {
      return null;
    }
    const seats = this.addSeatsTotal();
    const term = periodTermLabel(billingPeriodLabelToSlug(this.plan_type));
    const tax = isInr ? ' + GST' : '';
    return `${seats} seats × ${this.money(perSeat)}/${term} = ${this.money(seats * perSeat)}${tax}`;
  }

  /** Shown only when the renewal is close, so people know new seats roll into it. */
  renewalSoonHint(): string | null {
    if (this.selected_plan_type !== 'addon' || !this.expire_date || !this.today_date) {
      return null;
    }
    const days = Math.ceil(this.expiringDate(this.expire_date, this.today_date));
    if (!(days >= 0 && days <= 30)) {
      return null;
    }
    return `Your renewal is in ${days} day${days === 1 ? '' : 's'}. Seats you add now are included automatically.`;
  }

  nudgeSeats(delta: number): void {
    const next = Math.max(this.min, Math.trunc(Number(this.user) || 1) + delta);
    this.onKey(next);
    this.billingAnalytics.track('seats_changed', {
      seats: next,
      band: next <= 4 ? '1-4' : next <= 29 ? '5-29' : '30+',
    });
  }

  preselectBestPeriodForCheckout(): void {
    if (this.selected_plan_type === 'addon') {
      return;
    }
    const seats = Math.max(1, Number(this.user) || 1);
    if (seats >= 5) {
      this.selectPlanTypeAction('yearly');
    }
  }

  checkoutChangesLine(): string | null {
    if (this.checkoutMode === 'tier_upgrade') {
      return `Upgrade ${planCodeDisplayName(this.currentPlanCode)} → ${planCodeDisplayName(this.checkoutPlanCode)}`;
    }
    if (this.checkoutMode === 'renew' || this.isToggle) {
      const parts: string[] = [];
      if (Number(this.user) !== Number(this.quota_allowed)) {
        parts.push(`${this.quota_allowed} → ${this.user} seats`);
      }
      if (
        billingPeriodLabelToSlug(this.plan_type) !==
        billingPeriodLabelToSlug(this.subscriptionBillingPeriod)
      ) {
        parts.push(`${this.subscriptionBillingPeriod} → ${this.plan_type}`);
      }
      return parts.length ? `Changes: ${parts.join(' · ')}` : null;
    }
    return null;
  }

  renewalTermLine(): string | null {
    if (this.checkoutMode !== 'renew' && !this.isToggle) {
      return null;
    }
    if (!this.expire_date) {
      return null;
    }
    const end = this.checkoutTermEndDate();
    if (!end) {
      return null;
    }
    const start = this.formattedDate(this.checkoutTermStartDate());
    return `New term ${start} – ${this.formattedDate(end)}`;
  }

  retryBillingQuote(): void {
    this.quoteErrorMessage = '';
    this.quoteSeatsShortfall = null;
    this.quoteRequiredSeats = null;
    this.scheduleBillingQuoteRefresh();
  }

  /** Per-seat price of a tier at a seat count and billing period. */
  private tierSeatPrice(
    planCode: string,
    periodOverride?: BillingPeriodSlug,
    seatsOverride?: number
  ): { term: number; monthly: number; period: BillingPeriodSlug; seats: number } | null {
    const products = (this.plan_data || []) as WcSeatProduct[];
    if (!products.length) {
      return null;
    }
    const currency = resolveWcCurrencyScope(this.billing_country);
    const period =
      periodOverride ||
      billingPeriodLabelToSlug(this.subscriptionBillingPeriod || this.plan_type);
    const seats =
      seatsOverride != null
        ? Math.max(1, seatsOverride)
        : Math.max(1, Number(this.quota_allowed) || 5);
    const product = findBundledSeatProduct(products, planCode, period, currency, seats);
    if (!product) {
      return null;
    }
    const term =
      currency === 'usd'
        ? readProductUsdPrice(product, this.billing_country)
        : readProductInrPrice(product);
    if (!term) {
      return null;
    }
    return { term, monthly: effectiveMonthlyFromPrepaid(term, period), period, seats };
  }

  private priceText(amount: number): string {
    const prefix = this.billing_country === 'IN' ? '₹' : '$';
    return `${prefix}${amount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
  }

  /** Column header price: "₹506 /seat/month", "billed yearly · 50 seats". */
  tierPriceParts(tier: PlanTierCard): { amount: string; note: string } | null {
    const period = this.comparePeriodSlug();
    const seats = this.compareSeatCount();
    const key = `${period}|${seats}|${this.billing_country || ''}`;
    const products = this.plan_data;
    let cache = this.tierPriceCache;
    if (!cache || cache.key !== key || cache.products !== products) {
      cache = { key, products, map: new Map() };
      this.tierPriceCache = cache;
    }
    const code = tier.plan_code || '';
    if (cache.map.has(code)) {
      return cache.map.get(code) ?? null;
    }
    const price = this.tierSeatPrice(code, period, seats);
    if (!price) {
      cache.map.set(code, null);
      return null;
    }
    const billed =
      price.period === 'monthly'
        ? 'billed monthly'
        : price.period === 'quarterly'
          ? 'billed quarterly'
          : 'billed annually';
    const termNote =
      price.period === 'monthly'
        ? ''
        : ` · ${this.priceText(price.term)}/${periodTermLabel(price.period)}`;
    const parts = {
      amount: this.priceText(Math.round(price.monthly * 100) / 100),
      note: `${billed} · ${price.seats} seats${termNote}`,
    };
    cache.map.set(code, parts);
    return parts;
  }

  /** What the company pays per seat for its current plan, e.g. "₹7,970 per seat / year". */
  currentSeatPriceLine(): string {
    if (this.isTrialCompany()) {
      return '';
    }
    const price = this.tierSeatPrice(this.currentPlanCode);
    return price ? `${this.priceText(price.term)} per seat / ${periodTermLabel(price.period)}` : '';
  }

  maybeTrackBillingView(): void {
    if (this.billingViewTracked || this.loading) {
      return;
    }
    this.billingViewTracked = true;
    this.billingAnalytics.track('billing_viewed', { state: this.billingState() });
  }

  checkPlanDetail() {
    this.isButtonDisable = true;
    this.determinePaymentParameters();

    // Show confirmation dialog if auto-renew is enabled
    this.validateAutoRenewState().then((confirmed) => {
      if (confirmed) {
        this.processCheckPlanDetail();
      } else {
        this.isButtonDisable = false;
      }
    });
  }

  /**
   * Processes the plan detail check after auto-renew confirmation
   */
  private processCheckPlanDetail() {
    this.isButtonDisable = true;
    this.determinePaymentParameters();

    let taxDetails: { gst?: string, igst?: string } | null = null;
    if (this.payment_mode === 'domestic') {
      if (this.isGST && this.txtGst && this.txtGst.trim() !== '') {
        if (this.determined_tax_type === 'cgst_sgst') {
          taxDetails = { gst: this.txtGst };
        } else if (this.determined_tax_type === 'igst') {
          taxDetails = { igst: this.txtGst };
        }
      }
    }

    this._projectService.purchasePlan(
      this.plan_id,
      this.user,
      this.selected_plan_type,
      taxDetails,
      this.payment_mode,
      this.auto_renew,
      true,
      null,
      this.purchasePlanExtra()
    )
      .subscribe((data: any) => {
        this.isSetDebounceTime = false;
        this.order_Id = data.order_id;
        const key = data.key
        const paymentCurrency = this.payment_mode === 'international' ? 'USD' : 'INR';
        this.openRazorpayCheckout(
          data.order_id,
          data.amount,
          data.callback_url,
          paymentCurrency,
          key
        );
        this.isButtonDisable = false;

      }, (error: any) => {
        this.isSetDebounceTime = false;
        this.isButtonDisable = false;
        const errorMessage = (error && error.error && error.error.message) ? error.error.message : "";

        if (error && error.error && error.error.code == "rest_plan_downgrade") {
          this.handlePlanDowngradeError(error);
        } else {
          this._snackBar.open(errorMessage, 'Close', { duration: 3000 });
        }
      })
  }



  /**
   * Resets the auto-renew state to default (disabled)
   */
  resetAutoRenewToDefault() {
    this.auto_renew = false;
  }

  /**
   * Handles auto-renew toggle change with user confirmation
   */
  // onAutoRenewToggleChange(event: any) {
  //   if (!event.checked) {
  //     // User is disabling auto-renew, show confirmation
  //     this.sweetAlertService.showConfirmation(
  //       'Disable Auto-Renewal',
  //       'Are you sure you want to disable auto-renewal? Your subscription will not automatically renew and you may lose access to services when it expires.',
  //       'Yes, Disable',
  //       'Keep Enabled'
  //     ).then((result) => {
  //       if (result.isConfirmed) {
  //         this.auto_renew = false;
  //       } else {
  //         // User cancelled, keep auto-renew enabled
  //         this.auto_renew = true;
  //         // Need to update the toggle back to checked state
  //         setTimeout(() => {
  //           const toggleElement = document.querySelector('mat-slide-toggle') as any;
  //           if (toggleElement) {
  //             toggleElement.checked = true;
  //           }
  //         }, 100);
  //       }
  //     });
  //   }
  // }

  /**
   * Validates auto-renew state and shows appropriate confirmation
   */
  validateAutoRenewState(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.auto_renew) {
        const planType = this.plan_type === 'Monthly' ? 'month' : 'year';
        // this.sweetAlertService.showConfirmation(
        //   'Auto-Renewal Confirmation',
        //   `You have enabled auto-renewal for this plan. Your subscription will automatically renew every ${planType} and you will be charged accordingly. Do you want to proceed with the purchase?`,
        //   'Yes, Proceed',
        //   'Cancel'
        // ).then((result) => {
        //   resolve(result.isConfirmed);
        // });
        resolve(true);
      } else {
        resolve(true); // No confirmation needed for disabled auto-renew
      }
    });
  }

  AdvancePaymentRequest() {

  }

  isToggleChange(event) {
    this.isToggle = event.checked;
    if (this.isToggle) {
      this.strPlan = `Pay`
    }
    this.calculateTotalAmount();
  }


  onKey(value?: any) {
    if (value == null || value == undefined || value == "") {
      value = 1;
    }

    let next: number | null = null;
    if (value >= this.min) {
      next = Math.trunc(Number(value));
    } else if (value <= 0 && value != '') {
      next = 1;
    } else if (value != '') {
      next = Math.trunc(Number(value));
    } else {
      this.totalUser = 0;
      return;
    }

    // The seat box emits again while the compare table paints. Repricing on
    // that repeat is what locks the tab. Same number means the price is current.
    if (next === this.lastPricedSeatCount && next === Math.trunc(Number(this.user))) {
      return;
    }

    this.isHint = false;
    this.user = next;
    this.lastPricedSeatCount = next;
    if (value < this.min) {
      this.totalUser = 0;
    }
    this.applySeatProductSelectionFromCatalog();
    this.calculateTotalAmount();
  }

  selectPlanAction(strplan) {
    if (this.selected_plan_type != 'addon') {
      if (this.isMicroTeamSeats() && strplan !== 'yearly') {
        return;
      }
      this.selectPlanTypeAction(strplan);
    }
  }

  selectPlanTypeAction(strplan) {
    const slug = (strplan || '').toString().toLowerCase().trim();
    this.monthlyBackground = '';
    this.quarterlyBackground = '';
    this.yearlyBackground = '';
    if (slug === 'monthly' || slug === 'month') {
      this.monthlyBackground = 'monthly-btn-bg-color';
      this.plan_type = 'Monthly';
    } else if (slug === 'quarterly' || slug === 'quarter') {
      this.quarterlyBackground = 'monthly-btn-bg-color';
      this.plan_type = 'Quarterly';
    } else if (billingPeriodLabelToSlug(slug) === 'semiannual' && slug) {
      this.plan_type = 'Semi-annual';
    } else {
      this.yearlyBackground = 'monthly-btn-bg-color';
      this.plan_type = 'Yearly';
    }

    // Reset auto-renew to default when plan type changes
    this.resetAutoRenewToDefault();

    this.applySeatProductSelectionFromCatalog();
    this.calculateTotalAmount();
  }

  calculateTotalAmount() {
    this.strSubCaption = '';
    this.strCaption = '';
    this.strDateCption = '';
    this.strSubDateCaption = '';

    let current_selected_price_inr = this.selected_price;
    let current_selected_price_usd = this.selected_usd_price;
    if (this.selected_plan_type == 'main' || this.selected_plan_type == 'tier_upgrade') {
      this.totalUser = Number((this.user * current_selected_price_inr).toFixed(0));
      this.totalUser_usd = Number((this.user * current_selected_price_usd).toFixed(0));
    }

    // Local baseline so the Total reflects the selected cadence/seats right
    // away. The server quote (proration / GST) refines this when a billing
    // profile is present.
    if (this.billing_country === 'IN') {
      this.totalInr =
        parseBillingAmount(this.totalUser) + parseBillingAmount(this.gstPrice);
    } else {
      this.totalUsd = parseBillingAmount(this.totalUser_usd);
    }

    this.scheduleBillingQuoteRefresh();
  }

  /** True when Woo plan + billing country are ready for rao/v2/upgrade preview. */
  private canRequestBillingQuote(): boolean {
    return (
      !!this.plan_id &&
      this.plan_id > 0 &&
      !!this.billing_country &&
      !!this.user &&
      this.user >= this.min
    );
  }

  /** Debounced upgrade preview — avoids 400s from plan_id 0 during page init. */
  private scheduleBillingQuoteRefresh(): void {
    if (this.billingQuoteTimer) {
      clearTimeout(this.billingQuoteTimer);
    }
    if (!this.canRequestBillingQuote()) {
      return;
    }
    this.billingQuoteTimer = setTimeout(() => {
      this.billingQuoteTimer = null;
      if (this.canRequestBillingQuote()) {
        this.getBillingDetails();
      }
    }, 280);
  }

  calculateProratedPrice(userCount: number, daysDifference: number, totalDaysInPlan: number, basePricePerUser: number): number {
    if (daysDifference <= 0 || totalDaysInPlan <= 0 || basePricePerUser <= 0) {
      return 0;
    }
    const dailyPrice = Number((basePricePerUser / totalDaysInPlan).toFixed(4));

    const totalPriceForOneUser = Number((dailyPrice * daysDifference).toFixed(2));

    const totalNetPrice = totalPriceForOneUser * userCount;

    return Number(totalNetPrice.toFixed(2));
  }

  getActiveAddonDetails(): { icon: string; label: string; color?: string }[] {
    const details: { icon: string; label: string; color?: string }[] = [];
    const activeAddOns = this.companyAddOns.filter((addon) => addon.enabled);

    activeAddOns.forEach(addon => {
      let icon = 'stars';
      let color = 'text-slate-500';
      if (addon.key === 'webcam_capture') {
        icon = 'photo_camera';
        color = 'text-[#5459d1]'; // Indigo for photo capture
      } else if (addon.key === 'custom_periodic_interval') {
        icon = 'timer';
        color = 'text-[#d97706]'; // Amber for time intervals
      } else if (addon.key === 'custom_screencast_limit') {
        icon = 'videocam';
        color = 'text-[#ef4444]'; // Red for live video recording
      }

      const label = addon.label || ENTITLEMENT_LABELS[addon.key] || addon.key;

      if (!details.find(d => d.label === label)) {
        details.push({ icon, label, color });
      }
    });

    return details;
  }

  get hasActiveAddons(): boolean {
    return this.getActiveAddonDetails().length > 0;
  }

  advancePayAction(strplan) {
    if (strplan == 'add_more') {
      this.moreUserBackground = 'monthly-btn-bg-color';
      this.payAcdvanceBackground = '';
      this.isToggle = false;
      this.auto_renew = false; // Disable auto-renew for addon plans
      this.selected_plan_type = 'addon';
      this.user = 1;
      this.min = 1;
    } else {
      this.moreUserBackground = '';
      this.payAcdvanceBackground = 'monthly-btn-bg-color';
      this.strPlan = `Pay`
      this.isToggle = true;
      this.selected_plan_type = 'main';
      this.user = this.quota_allowed;
      // Renewal may reduce seats down to active users (SUSEE-1547).
      this.min = Math.max(Number(this.useUser) || 1, 1);
      this.resetAutoRenewToDefault();
    }
    this.calculateTotalAmount();
  }

  private catalogRequestInFlight = false;

  loadPlanCatalog(): void {
    if (this.catalogRequestInFlight) {
      return;
    }
    this.catalogRequestInFlight = true;
    const catalogT0 = performance.now();
    console.info('[Billing] loadPlanCatalog start');
    this.planCatalogLoading = true;
    // Catalog hangs showed as a stuck Compare-plans skeleton even once the
    // hero rendered. Treat a non-response as a soft failure and fall back
    // to the baked-in tier list so the page is never half-stuck.
    this._projectService.getPlansCatalog().pipe(
      timeout(15000),
      catchError((err) => {
        console.error('loadPlanCatalog: timed out or failed; using fallback tiers.', err);
        return of({ tiers: [] } as unknown);
      })
    ).subscribe({
      next: (raw: unknown) => {
        const data = raw as PlansCatalogResponse;
        this.planTiers = data.tiers || [];
        if (data.current_plan_code) {
          this.currentPlanCode = normalizeProductTierCode(data.current_plan_code) || data.current_plan_code;
          if (!this.isTrialCompany()) {
            this.checkoutPlanCode = data.current_plan_code;
            this.checkoutTierChosenByUser = false;
          } else {
            this.syncCheckoutPlanCodeFromContext();
          }
          this.productTierDisplay = this.isTrialCompany() ? '' : planCodeDisplayName(data.current_plan_code);
          this.currentSelectedPlant = this.productTierDisplay;
        } else if (this.isTrialCompany()) {
          this.syncCheckoutPlanCodeFromContext();
        }
        this.selfServeTierChange = !!data.self_serve_enabled;
        this.tierUpgradeProrateEnabled = !!data.tier_upgrade_prorate_enabled;
        this.pricingMode =
          (data.pricing_mode || '').toLowerCase() === 'custom' ? 'custom' : 'standard';
        this.syncTierSeatFeatures();
        if (!this.planTiers.length) {
          this.planTiers = this.fallbackPlanTiers();
        }
        if (this.plan_data?.length) {
          this.applySeatProductSelectionFromCatalog();
          this.calculateTotalAmount();
        }
        this.catalogRequestInFlight = false;
        this.planCatalogLoading = false;
        this.cdr.markForCheck();
        this.applyBillingIntent();
        console.info('[Billing] loadPlanCatalog next → tiers rendered', {
          elapsedMs: Math.round(performance.now() - catalogT0),
          tierCount: this.planTiers.length,
        });
        this.checkUrlForPlanSelection();
      },
      error: () => {
        this.catalogRequestInFlight = false;
        this.planCatalogLoading = false;
        if (!this.planTiers.length) {
          this.planTiers = this.fallbackPlanTiers();
        }
        this.cdr.markForCheck();
        this.applyBillingIntent();
        console.warn('[Billing] loadPlanCatalog error branch — using fallback tiers', {
          elapsedMs: Math.round(performance.now() - catalogT0),
          tierCount: this.planTiers.length,
        });
        this.checkUrlForPlanSelection();
      },
    });
  }

  checkUrlForPlanSelection(): void {
    const planParam = this.route.snapshot.queryParams['plan'];
    if (planParam && this.planTiers.length) {
      const tier = this.planTiers.find((t) => t.plan_code === planParam);
      if (tier && !this._dialog.openDialogs.length) {
        setTimeout(() => {
          // Clear first; the flow puts it back only if a checkout for that plan opens.
          this.setPlanQueryParam(null);
          this.onTierCta(tier);
        }, 100);
      }
    }
  }

  private fallbackPlanTiers(): PlanTierCard[] {
    return [
      {
        plan_code: 'basic',
        name: 'Basic',
        tagline: 'Employee monitoring essentials — screenshots & attendance',
        highlights: [
          'App & website usage reports',
          'Employee-controlled monitoring',
          '1 work shift',
          'Screenshots every 10+ minutes',
        ],
      },
      {
        plan_code: 'professional',
        name: 'Professional',
        tagline: 'See the team’s workday — live screen & screenshot timeline',
        recommended: true,
        highlights: [
          'Everything in Basic',
          'Live Wall (live screen) & Productivity Trends',
          'Work Replay (screenshot timeline)',
          'Auto tracking & faster screenshots',
        ],
      },
      {
        plan_code: 'business',
        name: 'Business',
        tagline: 'Longer retention and reports for larger teams',
        highlights: [
          'Everything in Professional',
          'Screenshots kept longer',
          'Executive reports',
          'Priority setup help',
        ],
      },
    ];
  }

  planTierRank(planCode: string): number {
    const rank = productTierRank(planCode);
    return rank >= 0 ? rank : 0;
  }

  private normalizedTierCode(planCode: string): string {
    return normalizeProductTierCode(planCode) || planCode;
  }

  /** Recommended only makes sense for a tier above the one the customer is on. */
  showRecommendedBadge(tier: PlanTierCard): boolean {
    if (!tier.recommended || this.isCurrentPlanTier(tier)) {
      return false;
    }
    return (
      this.isTrialCompany() ||
      this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode)
    );
  }

  isDowngradeTier(tier: PlanTierCard): boolean {
    return (
      !this.isTrialCompany() &&
      !this.isCurrentPlanTier(tier) &&
      this.planTierRank(tier.plan_code) < this.planTierRank(this.currentPlanCode)
    );
  }

  isCurrentPlanTier(tier: PlanTierCard): boolean {
    return (
      !this.isTrialCompany() &&
      this.normalizedTierCode(tier.plan_code) === this.normalizedTierCode(this.currentPlanCode)
    );
  }

  isCheckoutTierSelected(tier: PlanTierCard): boolean {
    return this.isTrialCompany() && tier.plan_code === this.checkoutPlanCode;
  }

  tierCtaLabel(tier: PlanTierCard): string {
    if (this.isCurrentPlanTier(tier)) {
      return 'Current tier';
    }
    if (this.isCheckoutTierSelected(tier)) {
      return 'Selected';
    }
    if (
      this.pricingMode === 'custom' &&
      this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode)
    ) {
      return 'Request upgrade quote';
    }
    // Trials and expired plans pick the plan they will pay for; nothing is upgraded in place.
    if (this.isTrialCompany() || this.billingState() === 'expired') {
      return `Choose ${tier.name}`;
    }
    if (this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode)) {
      return `Upgrade to ${tier.name}`;
    }
    return `Downgrade to ${tier.name}`;
  }

  isTierCtaDisabled(tier: PlanTierCard): boolean {
    return (
      this.isCurrentPlanTier(tier) ||
      this.isCheckoutTierSelected(tier) ||
      this.tierActionPlanCode !== null ||
      this.transitionValidationLoading
    );
  }

  isTierCtaLoading(tier: PlanTierCard): boolean {
    return (
      this.tierActionPlanCode === tier.plan_code ||
      (this.transitionValidationLoading &&
        this.transitionValidationTargetPlanCode === tier.plan_code)
    );
  }

  onTierCta(tier: PlanTierCard): void {
    if (this.isTierCtaDisabled(tier)) {
      return;
    }

    const isUpgrade =
      (this.isTrialCompany() && tier.plan_code !== 'basic') ||
      (!this.isTrialCompany() &&
        !isProductTierDowngrade(this.currentPlanCode, tier.plan_code) &&
        this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode));

    if (!isUpgrade) {
      this.beginDowngradeFlow(tier);
      return;
    }

    // Expired accounts reactivate on the chosen plan; the checkout shows the price, so no extra dialog.
    if (this.billingState() === 'expired' && !this.hasActiveAddons && this.pricingMode !== 'custom') {
      this.startTierCheckout(tier.plan_code, tier.name);
      return;
    }

    if (
      this.pricingMode === 'custom' &&
      this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode)
    ) {
      this.billingAnalytics.track('help_clicked', { channel: 'whatsapp', reason: 'custom_pricing_upgrade' });
      window.open(this.supportWhatsAppUrl(`upgrade to ${tier.name}`), '_blank', 'noopener');
      return;
    }

    if (this.hasActiveAddons) {
      this.showAddonUpgradeRestrictionDialog();
      return;
    }

    // Paid mid-term upgrade with prorated charge (SUSEE-1547).
    if (
      this.tierUpgradeProrateEnabled &&
      !this.isTrialCompany() &&
      this.isPaidSubscriptionActive() &&
      this.planTierRank(tier.plan_code) > this.planTierRank(this.currentPlanCode)
    ) {
      this.startTierUpgradeCheckout(tier.plan_code, tier.name);
      return;
    }

    const modalTitle = this.isTrialCompany()
      ? (this.checkoutPlanCode ? `Switch to ${tier.name}?` : `Choose ${tier.name}?`)
      : `Upgrade to ${tier.name}?`;
    const modalMessage = this.isTrialCompany()
      ? 'This sets the paid plan you want to start after checkout.'
      : 'This updates which features your company can use in the app.';
    const modalHint = this.isTrialCompany()
      ? 'Billing starts only after successful payment.'
      : this.tierBillingTrustLine();
    const gains = this.isTrialCompany()
      ? []
      : planCompareGains(this.normalizedTierCode(this.currentPlanCode), this.compareCode(tier));

    const ref = this._dialog.open(PlanUpgradeDialogComponent, {
      width: 'auto',
      maxWidth: '540px',
      data: {
        title: modalTitle,
        message: modalMessage,
        hint: modalHint,
        hintTitle: gains.length ? `What ${tier.name} adds` : undefined,
        hintList: gains.map((text) => ({ icon: 'check_circle', text, color: 'text-[#16a34a]' })),
        hintFooter: gains.length ? modalHint : undefined,
        icon: 'help',
        confirmLabel: 'Continue',
        cancelLabel: 'Cancel',
      },
    });
    ref.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.startTierCheckout(tier.plan_code, tier.name);
      } else {
        this.setPlanQueryParam(null);
      }
    });
  }

  /**
   * Keep ?plan= in step with the open checkout so the URL never names a plan the page is not
   * showing (and a reload does not re-open a flow that was dismissed).
   */
  private setPlanQueryParam(planCode: string | null): void {
    // Never pull the user back here after they navigated to another page.
    if (this.destroyed) {
      return;
    }
    // Later calls win: the router cancels an earlier in-flight navigation.
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { plan: planCode },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  private startTierCheckout(planCode: string, planName: string): void {
    // Capture before we mutate checkout state — switching Basic/Pro/Business must not
    // wipe a seat count the customer already chose (SUSEE-1551).
    const previousSeats = Math.max(0, Math.trunc(Number(this.user) || 0));
    const preserveSelectedSeats = this.seatCheckoutExpanded && previousSeats > 0;

    this.checkoutTierChosenByUser = true;
    this.checkoutPlanCode = planCode;
    this.checkoutMode = 'setup';
    this.selected_plan_type = 'main';
    const expired = this.billingState() === 'expired';
    if (expired) {
      // Same seat rule as the default reactivation checkout: never below headcount.
      const floor = this.seatFloorFromHeadcount();
      this.user = preserveSelectedSeats
        ? Math.max(previousSeats, floor, 1)
        : Math.max(Number(this.quota_allowed) || 1, floor, 1);
      this.min = floor;
    } else {
      const floor = Math.max(Number(this.useUser) || 1, 1);
      this.user = preserveSelectedSeats
        ? Math.max(previousSeats, floor, 1)
        : Math.max(Number(this.quota_allowed) || 1, this.min || 1);
      this.min = floor;
    }
    this.isToggle = false;
    this.strPlan = 'Pay';
    this.auto_renew = false;
    this.seatCheckoutPanelTitle = expired
      ? `Reactivate ${planName}`
      : this.isTrialCompany()
        ? `Set up ${planName} seat subscription`
        : `Upgrade to ${planName}`;
    this.seatCheckoutExpanded = true;
    this.setPlanQueryParam(planCode);
    this.applySeatProductSelectionFromCatalog();
    this.preselectBestPeriodForCheckout();
    this.syncTierSeatFeatures();
    this.calculateTotalAmount();
    this.isSetDebounceTime = false;
    this.scrollToSeatCheckoutPanel();
    this.billingAnalytics.track('checkout_opened', { mode: this.checkoutMode, tier: planCode });
  }

  /** Mid-term paid upgrade: charge prorated difference for remaining days. */
  private startTierUpgradeCheckout(planCode: string, planName: string): void {
    this.checkoutTierChosenByUser = true;
    this.checkoutPlanCode = planCode;
    this.checkoutMode = 'tier_upgrade';
    this.selected_plan_type = 'tier_upgrade';
    this.user = Math.max(Number(this.quota_allowed) || 1, 1);
    this.min = this.user;
    this.isToggle = false;
    this.strPlan = 'Pay';
    this.auto_renew = false;
    this.seatCheckoutPanelTitle = `Upgrade to ${planName}`;
    this.seatCheckoutExpanded = true;
    this.setPlanQueryParam(planCode);
    this.syncSeatCheckoutBillingPeriod();
    this.applySeatProductSelectionFromCatalog();
    this.syncTierSeatFeatures();
    this.calculateTotalAmount();
    this.isSetDebounceTime = false;
    this.scrollToSeatCheckoutPanel();
    this.billingAnalytics.track('tier_upgrade_quoted', {
      from: this.currentPlanCode,
      to: planCode,
    });
    this.billingAnalytics.track('checkout_opened', { mode: 'tier_upgrade', tier: planCode });
  }

  private resolvePlanIdForCode(planCode: string): number {
    if (!this.plan_data || !this.plan_data.length) {
      return 0;
    }
    const currency = resolveWcCurrencyScope(this.billing_country);
    const periodSlug =
      this.selected_plan_type === 'addon'
        ? billingPeriodLabelToSlug(this.subscriptionBillingPeriod || this.plan_type)
        : billingPeriodLabelToSlug(this.plan_type);
    const seats = this.seatsForBandProduct();
    const product = findBundledSeatProduct(
      this.plan_data,
      planCode,
      periodSlug,
      currency,
      seats
    );
    return product ? product.id : 0;
  }

  private submitTierChange(planCode: string, options?: { transitionValidated?: boolean }): void {
    const normalizedPlanCode = this.normalizedTierCode(planCode);
    this.tierActionPlanCode = normalizedPlanCode;

    const planId = this.resolvePlanIdForCode(normalizedPlanCode);
    const qty = this.quota_allowed || this.user || 1;
    const type = 'main';
    const mode = this.payment_mode || (this.billing_country === 'IN' ? 'domestic' : 'international');
    const autoRenew = this.auto_renew;
    const createOrder = true;

    this._projectService
      .requestProductTierChange(normalizedPlanCode, {
        transitionValidated: options?.transitionValidated,
        plan_id: planId,
        qty: qty,
        type: type,
        mode: mode,
        auto_renew: autoRenew,
        create_order: createOrder
      })
      .subscribe({
        next: (raw: unknown) => {
          this.tierActionPlanCode = null;
          const res = raw as ProductTierChangeResponse;
          if (res.current_plan_code) {
            this.currentPlanCode =
              normalizeProductTierCode(res.current_plan_code) || res.current_plan_code;
            this.productTierDisplay = planCodeDisplayName(res.current_plan_code);
            this.currentSelectedPlant = this.productTierDisplay;
          }

          if (res.applied) {
            const appliedPlanCode =
              normalizeProductTierCode(res.current_plan_code || normalizedPlanCode) ||
              normalizedPlanCode;
            this._snackBar.open(
              res.message ||
              `Your plan is now ${planCodeDisplayName(appliedPlanCode)}. Billing and entitlements have been updated.`,
              'Close',
              { duration: 8000 }
            );
            this.refreshBillingAfterTierApplied(appliedPlanCode);
          } else {
            this._snackBar.open(res.message || 'Request received.', 'Close', {
              duration: 8000,
            });
          }

          if (res.action === 'checkout_then_contact') {
            this.expandSeatCheckout('add');
            if (res.contact_url) {
              window.open(res.contact_url, '_blank');
            }
          } else if (res.action === 'contact_support' && res.contact_url) {
            this._snackBar
              .open(
                res.message ||
                'Your workspace is ready, but this tier change still needs support to finalize.',
                'Contact support',
                { duration: 10000 }
              )
              .onAction()
              .subscribe(() => window.open(res.contact_url, '_blank'));
          }
        },
        error: (err) => {
          const attemptedPlanCode = planCode;
          this.tierActionPlanCode = null;
          if (err?.error?.code === 'rest_plan_downgrade') {
            this.handlePlanDowngradeError(err, attemptedPlanCode);
            return;
          }
          const msg =
            err?.error?.message || 'Could not update product tier. Please try again.';
          this._snackBar.open(msg, 'Close', { duration: 7000 });
        },
      });
  }

  private beginDowngradeFlow(tier: PlanTierCard): void {
    if (this.hasActiveAddons) {
      this.showAddonDowngradeRestrictionDialog();
      return;
    }

    const currentPlanCode = this.isTrialCompany()
      ? 'professional'
      : this.currentPlanCode;
    const targetPlanCode = this.normalizedTierCode(tier.plan_code);

    this.transitionValidationLoading = true;
    this.transitionValidationTargetPlanCode = targetPlanCode;
    this.planTransitionValidationService
      .validateTransition(targetPlanCode, this.normalizedTierCode(currentPlanCode))
      .subscribe({
        next: (report) => {
          this.transitionValidationLoading = false;
          this.transitionValidationTargetPlanCode = null;
          this.openDowngradeValidationDialog(tier, report);
        },
        error: () => {
          this.transitionValidationLoading = false;
          this.transitionValidationTargetPlanCode = null;
          this._snackBar.open(
            'Could not load downgrade compatibility report. Please try again.',
            'Close',
            { duration: 6000 }
          );
        },
      });
  }

  private openDowngradeValidationDialog(
    tier: PlanTierCard,
    report: PlanTransitionValidationResponse
  ): void {
    const dialogData = this.planTransitionValidationService.toDialogData(report);
    const ref = this._dialog.open(DowngradeValidationDialogComponent, {
      width: '920px',
      maxWidth: '95vw',
      disableClose: false,
      autoFocus: false,
      panelClass: 'downgrade-validation-dialog-container',
      data: dialogData,
    });

    ref.componentInstance.refreshValidation.subscribe(() => {
      this.refreshDowngradeValidationDialogInPlace(tier, ref.componentInstance);
    });

    ref.afterClosed().subscribe((result?: DowngradeValidationDialogResult) => {
      if (result && result.action === 'redirect') {
        return; // Navigation was already initiated by the dialog
      }

      // Only remove the query parameter if not currently navigating away
      if (!this.router.getCurrentNavigation()) {
        void this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { plan: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }

      if (!result || result.action === 'cancel') {
        return;
      }
      if (result.action === 'review') {
        void this.router.navigate(['/employee/setting']);
        return;
      }
      if (result.action === 'refresh') {
        this.refreshDowngradeValidationDialog(tier);
        return;
      }
      if (result.action === 'proceed') {
        this.startTierCheckout(tier.plan_code, tier.name);
      }
    });
  }

  private refreshDowngradeValidationDialog(tier: PlanTierCard): void {
    const currentPlanCode = this.isTrialCompany()
      ? 'professional'
      : this.currentPlanCode;

    this.transitionValidationLoading = true;
    this.transitionValidationTargetPlanCode = tier.plan_code;
    this.planTransitionValidationService
      .validateTransition(tier.plan_code, currentPlanCode, { forceRefresh: true })
      .subscribe({
        next: (report) => {
          this.transitionValidationLoading = false;
          this.transitionValidationTargetPlanCode = null;
          this.openDowngradeValidationDialog(tier, report);
        },
        error: () => {
          this.transitionValidationLoading = false;
          this.transitionValidationTargetPlanCode = null;
          this._snackBar.open(
            'Updated employee modes. Re-open downgrade review to see the latest status.',
            'Close',
            { duration: 6000 }
          );
        },
      });
  }

  private refreshDowngradeValidationDialogInPlace(
    tier: PlanTierCard,
    dialogInstance: DowngradeValidationDialogComponent
  ): void {
    const currentPlanCode = this.isTrialCompany()
      ? 'professional'
      : this.currentPlanCode;

    this.planTransitionValidationService
      .validateTransition(tier.plan_code, currentPlanCode, { forceRefresh: true })
      .subscribe({
        next: (report) => {
          const dialogData = this.planTransitionValidationService.toDialogData(report);
          dialogInstance.updateData(dialogData);
        },
        error: () => {
          this._snackBar.open(
            'Failed to refresh. Please close and re-open the downgrade review.',
            'Close',
            { duration: 6000 }
          );
        },
      });
  }

  /**
   * Quote failed because selected seats < people on the account.
   * Auto-bumps once to required seats (WP count is source of truth), else shows Add seats CTA.
   */
  private applySeatShortfallFromQuoteError(error: any): boolean {
    const payload = error?.error || {};
    const data = payload.data || {};
    let shortfall = Number(payload.seats_shortfall ?? data.seats_shortfall);
    let required = Number(payload.required_seats ?? data.required_seats);
    const employees = Number(payload.employees ?? data.employees);
    const msg = String(payload.message || '');

    if (!Number.isFinite(shortfall) || shortfall <= 0) {
      const m = msg.match(/add\s+(\d+)\s+seat/i) || msg.match(/remove\s+(\d+)\s+user/i);
      if (m) {
        shortfall = Number(m[1]);
      }
    }
    if ((!Number.isFinite(required) || required <= 0) && Number.isFinite(shortfall) && shortfall > 0) {
      required = Math.max(1, Number(this.user) || 0) + shortfall;
    }
    if (!Number.isFinite(shortfall) || shortfall <= 0) {
      return false;
    }

    if (Number.isFinite(employees) && employees > 0) {
      this.activeEmployeeCount = employees;
    } else if (Number.isFinite(required) && required > 0) {
      this.activeEmployeeCount = Math.max(this.activeEmployeeCount, required);
    }

    this.quoteSeatsShortfall = shortfall;
    this.quoteRequiredSeats = Number.isFinite(required) && required > 0 ? required : null;
    if (this.quoteRequiredSeats != null) {
      this.min = Math.max(Number(this.min) || 1, this.quoteRequiredSeats);
    }

    // Silent auto-fix once — avoids 10 vs 11 mismatch and $0 dead-end.
    if (
      !this.seatShortfallAutoFixAttempted &&
      this.quoteRequiredSeats != null &&
      Number(this.user) < this.quoteRequiredSeats
    ) {
      this.seatShortfallAutoFixAttempted = true;
      this.user = this.quoteRequiredSeats;
      this.quoteErrorMessage = '';
      this.quoteSeatsShortfall = null;
      this.quoteRequiredSeats = null;
      this.isLoadingPrice = true;
      setTimeout(() => {
        this.calculateTotalAmount();
        this.retryBillingQuote();
      }, 0);
      return true;
    }

    this.quoteErrorMessage =
      msg ||
      `You need ${shortfall} more seat${shortfall === 1 ? '' : 's'} to cover everyone on the account.`;
    return true;
  }

  /** Bump checkout seat qty to cover active people, then re-quote. */
  addSeatsToCoverQuoteShortfall(): void {
    const target =
      this.quoteRequiredSeats != null && this.quoteRequiredSeats > 0
        ? this.quoteRequiredSeats
        : Math.max(1, Number(this.user) || 0) + Math.max(1, Number(this.quoteSeatsShortfall) || 0);
    this.user = Math.max(target, Number(this.useUser) || 0, Number(this.min) || 1);
    this.min = Math.max(Number(this.min) || 1, this.user);
    this.activeEmployeeCount = Math.max(this.activeEmployeeCount, this.user);
    this.quoteErrorMessage = '';
    this.quoteSeatsShortfall = null;
    this.quoteRequiredSeats = null;
    this.calculateTotalAmount();
    this.retryBillingQuote();
  }

  private handlePlanDowngradeError(error: any, fallbackTargetPlanCode?: string): void {
    if (this.applySeatShortfallFromQuoteError(error)) {
      return;
    }
    const payload = error?.error;
    const resolvedTargetPlanCode =
      payload?.target_plan_code || fallbackTargetPlanCode || this.checkoutPlanCode;

    if (payload?.transition_report) {
      this.openDowngradeValidationDialog(
        {
          plan_code: resolvedTargetPlanCode,
          name: planCodeDisplayName(resolvedTargetPlanCode),
          tagline: '',
          highlights: [],
        },
        payload.transition_report as PlanTransitionValidationResponse
      );
      return;
    }

    const targetPlanCode = resolvedTargetPlanCode;
    const currentPlanCode = payload?.current_plan_code || this.currentPlanCode;
    if (
      targetPlanCode &&
      this.planTransitionValidationService.shouldValidate(currentPlanCode, targetPlanCode)
    ) {
      this.planTransitionValidationService
        .validateTransition(targetPlanCode, currentPlanCode)
        .subscribe({
          next: (report) => {
            this.openDowngradeValidationDialog(
              {
                plan_code: targetPlanCode,
                name: planCodeDisplayName(targetPlanCode),
                tagline: '',
                highlights: [],
              },
              report
            );
          },
          error: () => {
            this._snackBar.open(
              payload?.message || 'This plan change is not allowed until workspace settings are updated.',
              'Close',
              { duration: 7000 }
            );
          },
        });
      return;
    }

    this._snackBar.open(
      payload?.message || 'This plan change is not allowed until workspace settings are updated.',
      'Close',
      { duration: 7000 }
    );
  }

  scrollToSeatBilling(): void {
    const el = document.getElementById('manage-seats-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.triggerSeatSectionAttention();
    }
  }

  scrollToProductTiers(): void {
    this.compareExpanded = true;
    const el = document.getElementById('product-tier-heading');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  applyBillingIntent(): void {
    if (!this.pendingBillingIntent || this.loading) {
      return;
    }
    if (this.pendingBillingIntent === 'seats' && !this.heroPrimaryReady()) {
      return;
    }
    const intent = this.pendingBillingIntent;
    this.pendingBillingIntent = null;
    setTimeout(() => {
      if (intent === 'seats') {
        this.expandSeatCheckout('add');
      } else {
        this.focusUpgradeTier();
      }
    }, 150);
  }

  private lockedTierHighlightsForBasic(
    proHighlights: string[],
    basicSet: Set<string>
  ): string[] {
    return proHighlights
      .filter(
        (h) =>
          !basicSet.has(h) && !/^everything in /i.test(h.trim())
      )
      .slice(0, 3);
  }

  recommendedUpgradeTier(): PlanTierCard | null {
    if (this.isTrialCompany()) {
      return this.planTiers.find((t) => t.recommended) ||
        this.planTiers.find((t) => t.plan_code === 'professional') ||
        null;
    }
    if (this.currentPlanCode === 'basic') {
      return this.planTiers.find((t) => t.plan_code === 'professional') || null;
    }
    if (this.currentPlanCode === 'professional') {
      return this.planTiers.find((t) => t.plan_code === 'business') || null;
    }
    return null;
  }

  basicUpgradeTeaserSummary(): string {
    return this.tierSeatLockedTeasers.slice(0, 3).join(' · ');
  }

  compareCode(tier: PlanTierCard): string {
    return this.normalizedTierCode(tier.plan_code);
  }

  compareCell(row: PlanCompareRow, tier: PlanTierCard): PlanCompareValue | null {
    const value = row.values[this.compareCode(tier)];
    return value === undefined ? null : value;
  }

  /** Tiers offered in the phone tab switch; the current plan column is always shown. */
  compareTabTiers(): PlanTierCard[] {
    return this.planTiers.filter((t) => !this.isCurrentPlanTier(t));
  }

  /** Which non-current column a phone shows next to the current plan. */
  mobileCompareCode(): string {
    const tabs = this.compareTabTiers();
    if (this.compareMobileTier && tabs.some((t) => t.plan_code === this.compareMobileTier)) {
      return this.compareMobileTier;
    }
    return this.recommendedUpgradeTier()?.plan_code || tabs[0]?.plan_code || '';
  }

  isCompareColumnHiddenOnMobile(tier: PlanTierCard): boolean {
    return !this.isCurrentPlanTier(tier) && tier.plan_code !== this.mobileCompareCode();
  }

  /** Feature bullets without the catalog's "Everything in …" lines. */
  tierDisplayHighlights(tier: PlanTierCard): string[] {
    return (tier.highlights || []).filter(
      (h) => !/^everything in /i.test(h.trim())
    );
  }

  hasUpgradePath(): boolean {
    return !!this.recommendedUpgradeTier();
  }

  tierBillingTrustLine(): string {
    if (this.isTrialCompany()) {
      const trialDays = this.expire_date && this.today_date 
        ? Math.max(0, Math.ceil(this.expiringDate(this.expire_date, this.today_date))) 
        : this.trialDurationDays();
      return `Your company is on the Professional tier by default for the ${trialDays}-day trial. Choose a paid tier and complete checkout before trial ends.`;
    }
    if (this.tierUpgradeProrateEnabled) {
      return 'Upgrading product tier charges the price difference for the rest of this term. Your new seat rate applies from then on.';
    }
    if (this.selfServeTierChange) {
      return 'Upgrading product tier updates app features only — your seat subscription price stays the same until you add seats.';
    }
    return 'Product tier upgrades are separate from seat charges. You may need to complete checkout or contact support to finalize a tier change.';
  }

  scrollToRecommendedTierCard(): void {
    const target = this.recommendedUpgradeTier();
    if (!target) {
      this.scrollToProductTiers();
      return;
    }
    this.highlightRecommendedTier = true;
    setTimeout(() => {
      document.getElementById(`tier-card-${target.plan_code}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 80);
    setTimeout(() => {
      this.highlightRecommendedTier = false;
    }, 3500);
  }

  upgradeToRecommendedTier(): void {
    const tier = this.recommendedUpgradeTier();
    if (tier) {
      this.onTierCta(tier);
    } else {
      this.focusUpgradeTier();
    }
  }

  isTierHighlighted(tier: PlanTierCard): boolean {
    return (
      (this.highlightRecommendedTier && this.showRecommendedBadge(tier)) ||
      (this.highlightAppliedPlanTier && this.isCurrentPlanTier(tier))
    );
  }

  /** Reload billing catalog, seat SKUs, and entitlements after backend applies a tier change. */
  private refreshBillingAfterTierApplied(appliedPlanCode?: string): void {
    this.seatCheckoutExpanded = false;
    this.planCatalogLoading = true;

    forkJoin({
      catalog: this._projectService.getPlansCatalog().pipe(catchError(() => of(null))),
      plans: this._projectService.checkUserPlan().pipe(catchError(() => of([]))),
      user: this._projectService.refreshCurrentUser().pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ catalog, plans, user }) => {
        if (catalog) {
          const data = catalog as PlansCatalogResponse;
          this.planTiers = data.tiers || [];
          if (data.current_plan_code) {
            this.currentPlanCode =
              normalizeProductTierCode(data.current_plan_code) || data.current_plan_code;
            if (!this.isTrialCompany()) {
              this.checkoutPlanCode = this.currentPlanCode;
              this.checkoutTierChosenByUser = false;
            } else {
              this.syncCheckoutPlanCodeFromContext();
            }
            this.productTierDisplay = this.isTrialCompany()
              ? ''
              : planCodeDisplayName(data.current_plan_code);
            this.currentSelectedPlant = this.productTierDisplay;
          } else if (this.isTrialCompany()) {
            this.syncCheckoutPlanCodeFromContext();
          }
          this.selfServeTierChange = !!data.self_serve_enabled;
        }

        this.plan_data = Array.isArray(plans) ? plans : [];
        if (user) {
          const refreshedUser = user as UserWithEntitlements;
          this.loginUserInformation = refreshedUser;
          this.entitlementsService.syncFromUser(refreshedUser);
          this.finalizeUserDataProcessing(refreshedUser);
        } else {
          this.entitlementsService.syncFromSession();
          if (this.plan_data.length) {
            this.applySeatProductSelectionFromCatalog();
          }
          this.syncTierSeatFeatures();
          this.calculateTotalAmount();
        }

        this.planCatalogLoading = false;
        this.focusBillingProductTierSection(
          normalizeProductTierCode(appliedPlanCode) || this.currentPlanCode
        );
      },
      error: () => {
        this.planCatalogLoading = false;
        this.entitlementsService.syncFromSession();
        this.scrollToProductTiers();
      },
    });
  }

  private focusBillingProductTierSection(planCode?: string): void {
    const normalizedPlanCode = normalizeProductTierCode(planCode) || this.currentPlanCode;
    this.highlightAppliedPlanTier = true;

    const scrollToBilling = () => {
      const target =
        (normalizedPlanCode
          ? document.getElementById(`tier-card-${normalizedPlanCode}`)
          : null) || document.getElementById('product-tier-heading');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    setTimeout(scrollToBilling, 80);
    setTimeout(scrollToBilling, 260);
    setTimeout(() => {
      this.highlightAppliedPlanTier = false;
    }, 3500);
  }

  expandSeatCheckout(mode: 'add' | 'renew' | 'setup' = 'add', presetSeats = 1): void {
    // Expired / inactive must not use early-renew advance-pay (shows $0 + false "remove users").
    if (mode === 'renew' && !this.isPaidSubscriptionActive()) {
      mode = 'setup';
    }

    this.seatShortfallAutoFixAttempted = false;
    this.seatCheckoutExpanded = true;
    if (mode === 'renew') {
      this.checkoutMode = 'renew';
      this.seatCheckoutPanelTitle = 'Renew seat subscription early';
      this.advancePayAction('pay_advance');
      this.preselectBestPeriodForCheckout();
      this.billingAnalytics.track('checkout_opened', { mode: 'renew' });
    } else if (mode === 'add' && this.isPaidSubscriptionActive()) {
      this.checkoutMode = 'add';
      this.seatCheckoutPanelTitle = 'Add seats to your subscription';
      this.checkoutPlanCode = this.currentPlanCode;
      this.selected_plan_type = 'addon';
      this.user = Math.max(1, presetSeats);
      this.min = 1;
      this.isToggle = false;
      this.strPlan = 'Increase seat limit';
      this.auto_renew = false;
      this.syncSeatCheckoutBillingPeriod();
      this.applySeatProductSelectionFromCatalog();
      this.billingAnalytics.track('checkout_opened', { mode: 'add' });
    } else {
      this.checkoutMode = 'setup';
      this.syncCheckoutPlanCodeFromContext();
      const checkoutTierName = planCodeDisplayName(this.checkoutPlanCode);
      const expired =
        (this.quotaStatus || '').toLowerCase() === 'expired' ||
        this.billingState() === 'expired';
      this.seatCheckoutPanelTitle = expired
        ? checkoutTierName
          ? `Reactivate ${checkoutTierName}`
          : 'Reactivate your plan'
        : checkoutTierName
          ? `Set up ${checkoutTierName} seat subscription`
          : 'Set up seat subscription';
      this.selected_plan_type = 'main';
      const floor = this.seatFloorFromHeadcount();
      // Prefer headcount over stale quota (e.g. 5 seats left but 10 employees still on account).
      this.user = Math.max(Number(this.quota_allowed) || 1, floor, 1);
      this.min = floor;
      this.isToggle = false;
      this.strPlan = 'Pay';
      // Off by default for trust; reassurance copy only shows when the switch is on.
      this.auto_renew = false;
      this.applySeatProductSelectionFromCatalog();
      this.preselectBestPeriodForCheckout();
      this.billingAnalytics.track('checkout_opened', {
        mode: 'setup',
        expired,
        seats: this.user,
        headcount: this.activeEmployeeCount,
      });
    }
    this.syncTierSeatFeatures();
    this.calculateTotalAmount();
    this.isSetDebounceTime = false;
    this.scrollToSeatCheckoutPanel();
  }

  /**
   * Guides users to the next required billing step after a tier/action click.
   * We retry briefly because checkout panel renders after Angular updates.
   */
  private scrollToSeatCheckoutPanel(): void {
    this.triggerSeatSectionAttention();
    const scrollToTarget = () => {
      const target =
        document.getElementById('seat-checkout-panel') ||
        document.getElementById('manage-seats-section');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    setTimeout(scrollToTarget, 80);
    setTimeout(scrollToTarget, 220);
    setTimeout(scrollToTarget, 420);
  }

  private triggerSeatSectionAttention(): void {
    this.seatSectionAttention = true;
    if (this.seatAttentionTimer) {
      clearTimeout(this.seatAttentionTimer);
    }
    this.seatAttentionTimer = setTimeout(() => {
      this.seatSectionAttention = false;
      this.seatAttentionTimer = null;
    }, 3200);
  }

  collapseSeatCheckout(): void {
    this.seatCheckoutExpanded = false;
    this.setPlanQueryParam(null);
  }

  focusUpgradeTier(): void {
    this.compareExpanded = true;
    this.highlightRecommendedTier = true;
    this.scrollToProductTiers();
    const target =
      this.recommendedUpgradeTier() ||
      this.planTiers.find((t) => t.recommended);
    if (target) {
      setTimeout(() => {
        document.getElementById(`tier-card-${target.plan_code}`)?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 200);
      setTimeout(() => {
        this.highlightRecommendedTier = false;
      }, 4000);
    }
  }

  perSeatPriceLabel(): string {
    const period =
      this.selected_plan_type === 'addon'
        ? billingPeriodLabelToSlug(this.subscriptionBillingPeriod)
        : billingPeriodLabelToSlug(this.plan_type);
    const monthly =
      this.billing_country === 'IN'
        ? this.display_unit_price_inr
        : this.display_unit_price_usd;
    const term =
      this.billing_country === 'IN' ? this.selected_price : this.selected_usd_price;
    const currency = this.billing_country === 'IN' ? '₹' : '$';
    if (period === 'monthly') {
      return `${currency}${term} / seat / month`;
    }
    return `${currency}${monthly} / seat / month, billed ${periodDisplayName(period).toLowerCase()}`;
  }

  /** Seat summary price line — bundled tier sets per-seat rate (SUSEE-1316). */
  seatBundledPricingLine(): string {
    if (this.isTrialCompany()) {
      return 'No seat billing during trial. Payment starts only after checkout.';
    }
    const effectivePlanCode = this.checkoutPlanCode || this.defaultCheckoutPlanCode();
    const tier =
      planCodeDisplayName(effectivePlanCode) ||
      this.productTierDisplay ||
      planCodeDisplayName(this.currentPlanCode);
    return `${this.perSeatPriceLabel()} · ${tier} tier`;
  }

  /** Lock billing toggle to the active seat subscription cadence. */
  private syncSeatCheckoutBillingPeriod(): void {
    const slug = billingPeriodLabelToSlug(this.subscriptionBillingPeriod);
    this.monthlyBackground = '';
    this.quarterlyBackground = '';
    this.yearlyBackground = '';
    if (slug === 'yearly') {
      this.plan_type = 'Yearly';
      this.yearlyBackground = 'monthly-btn-bg-color';
    } else if (slug === 'quarterly') {
      this.plan_type = 'Quarterly';
      this.quarterlyBackground = 'monthly-btn-bg-color';
    } else if (slug === 'semiannual') {
      this.plan_type = 'Semi-annual';
    } else {
      this.plan_type = 'Monthly';
      this.monthlyBackground = 'monthly-btn-bg-color';
    }
  }

  seatSubscriptionSummaryLine(): string {
    if (this.isTrialCompany()) {
      const seats = this.quota_allowed || this.totalUserCurrent || 0;
      const valid = this.expire_date ? this.formattedDate(this.expire_date) : '—';
      const trialDays = this.expire_date && this.today_date ? Math.max(0, Math.ceil(this.expiringDate(this.expire_date, this.today_date))) : this.trialDurationDays();
      return `Professional Trial (${trialDays} days) · ${seats} trial seat${seats === 1 ? '' : 's'} · Ends ${valid}`;
    }
    const period = this.subscriptionBillingPeriod || this.plan_type;
    const seats = this.quota_allowed || this.totalUserCurrent || 0;
    const valid = this.expire_date ? this.formattedDate(this.expire_date) : '—';
    return `${period} · ${seats} seat${seats === 1 ? '' : 's'} · Valid ${valid}`;
  }

  seatSummaryBadgeLabel(): string {
    return this.isTrialCompany() ? 'Trial status' : 'Seat subscription';
  }

  showBasicUpgradeTeaser(): boolean {
    return this.currentPlanCode === 'basic' && this.tierSeatLockedTeasers.length > 0;
  }

  canChangeSeatBillingCadence(): boolean {
    return this.selected_plan_type !== 'addon' && this.selected_plan_type !== 'tier_upgrade';
  }

  toggleSubscriptionDetails(): void {
    this.subscriptionDetailsExpanded = !this.subscriptionDetailsExpanded;
  }

  /** Default catalog tier for checkout before the user picks a tier card. */
  private defaultCheckoutPlanCode(): string {
    if (this.isTrialCompany()) {
      return this.currentPlanCode || 'basic';
    }
    return this.currentPlanCode || 'professional';
  }

  /** Keep checkout tier aligned with trial/current plan until the user picks a card. */
  private syncCheckoutPlanCodeFromContext(): void {
    if (this.checkoutTierChosenByUser && this.checkoutPlanCode) {
      return;
    }
    this.checkoutPlanCode = this.defaultCheckoutPlanCode();
  }

  /** Catalog tier whose features are shown in seat checkout (target tier when upgrading). */
  private effectiveFeaturePlanCode(): string {
    if (this.selected_plan_type === 'addon') {
      return this.currentPlanCode;
    }
    return this.checkoutPlanCode || this.defaultCheckoutPlanCode();
  }

  seatBillingAccessLine(): string {
    if (!this.entitlementsService.isEnforcementActive()) {
      return 'Features for your purchased seats';
    }
    const tierName = planCodeDisplayName(this.effectiveFeaturePlanCode());
    if (tierName) {
      return `Features included with ${tierName}`;
    }
    return 'Features for your current product tier';
  }

  /** Seat price/cadence is Woo-only; tier cards above change app features, not per-seat price. */
  syncTierSeatFeatures(): void {
    const seatBasics: { label: string; included: boolean }[] = [
      { label: 'User seats (subscription limit)', included: true },
      { label: 'Team & individual dashboards', included: true },
      { label: 'Activity tracking & screenshots', included: true },
    ];

    const featurePlanCode = this.effectiveFeaturePlanCode();
    const displayTier = this.planTiers.find((t) => t.plan_code === featurePlanCode);
    if (displayTier?.highlights?.length) {
      const highlights = this.tierDisplayHighlights(displayTier);
      this.tierSeatFeatures = [
        ...seatBasics,
        ...highlights.map((label) => ({ label, included: true })),
      ];
      this.tierSeatLockedTeasers = [];
      if (featurePlanCode === 'basic') {
        const pro = this.planTiers.find((t) => t.plan_code === 'professional');
        const basicSet = new Set(displayTier.highlights);
        this.tierSeatLockedTeasers = this.lockedTierHighlightsForBasic(
          pro?.highlights || [],
          basicSet
        );
      }
      return;
    }

    const companyKeys = this.loginUserInformation?.meta?.entitlements?.company;
    if (Array.isArray(companyKeys) && companyKeys.length > 0) {
      this.tierSeatFeatures = [
        ...seatBasics,
        ...companyKeys.map((key: string) => ({
          label: ENTITLEMENT_LABELS[key] || key,
          included: true,
        })),
      ];
      this.tierSeatLockedTeasers = [];
      return;
    }

    this.tierSeatFeatures = [
      { label: 'Unlimited users and groups', included: true },
      { label: 'Team & individual dashboard', included: true },
      { label: 'Silent tracking', included: true },
      { label: 'Unlimited screenshots', included: true },
      { label: 'Activity tracking', included: true },
      { label: 'Live screencast', included: true },
      { label: 'Personalized dashboard', included: true },
    ];
    this.tierSeatLockedTeasers = [];
  }

  private applyPlanDisplayFromMeta(meta: any): void {
    this.subscriptionBillingPeriod = formatBillingPeriodOnly(meta);
    const code = normalizeProductTierCode(meta?.plan_code);
    if (code) {
      this.currentPlanCode = code;
      if (!this.isTrialCompany()) {
        this.checkoutPlanCode = code;
        this.checkoutTierChosenByUser = false;
      } else {
        this.syncCheckoutPlanCodeFromContext();
      }
    } else if (this.isTrialCompany()) {
      this.syncCheckoutPlanCodeFromContext();
    }
    this.productTierDisplay = this.isTrialCompany()
      ? `Basic (Trial ${this.trialDurationDays()} days)`
      : (planCodeDisplayName(meta?.plan_code) || '');
    this.currentSelectedPlant = this.subscriptionBillingPeriod;
    const companyKeys = meta?.entitlements?.company;
    if (Array.isArray(companyKeys) && companyKeys.length > 0) {
      this.entitlementFeatureSummary = companyKeys
        .map((key: string) => ENTITLEMENT_LABELS[key] || key)
        .join(', ');
    } else {
      this.entitlementFeatureSummary = '';
    }
    this.syncTierSeatFeatures();
    if (this.plan_data?.length) {
      this.applySeatProductSelectionFromCatalog();
    }
  }

  isTrialCompany(): boolean {
    const status = (this.quota_status || this.loginUserInformation?.meta?.quota_status || '')
      .toString()
      .toLowerCase();
    return status === 'trial' || status === 'trial-expired';
  }

  private trialDurationDays(): number {
    const parsed = Number(this.trial_grace_period);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 14;
  }

  isPaidSubscriptionActive(): boolean {
    return !this.isTrialCompany() && (
      (this.quota_status || '').toString().toLowerCase() === 'active' ||
      (this.quotaStatus || '').toString().toLowerCase() === 'active'
    );
  }

  expiringDate(strExpiredDate, strTodayDate) {
    const expirationDate = new Date(strExpiredDate);
    const timeDifference = expirationDate.getTime() - new Date(strTodayDate).getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return daysDifference;
  }

  formattedDate(expiresAt): string {
    const parsedDate = new Date(expiresAt);
    const formattedDate = this.datePipe.transform(parsedDate, 'MMM dd, yyyy');

    return formattedDate || '';
  }

  formatDuration(days: number, plan: string): string {
    if (plan === 'yearly') {
      days = days == 366 ? 365 : days; // Adjust for leap year if necessary
      const years = Math.floor(days / 365);
      const remainingDays = days % 365;
      if (years != 0) {
        if (remainingDays != 0) {
          return `${years} Year${years !== 1 ? 's' : ''}, ${remainingDays} Day${remainingDays !== 1 ? 's' : ''}`;
        } else {
          return `1 Year`;
        }
      } else {
        if (remainingDays != 0) {
          return `${days} Day${days !== 1 ? 's' : ''}`;
        } else {
          return `1 Year`;
        }
      }
    } else if (plan === 'monthly') {
      days = days == 31 ? 30 : days; // Adjust for month length if necessary
      const months = Math.floor(days / 30);
      const remainingDays = days % 30;
      console.log(months, remainingDays, "months")
      if (months != 0) {
        if (remainingDays != 0) {
          return `${months} Month${months !== 1 ? 's' : ''}, ${remainingDays} Day${remainingDays !== 1 ? 's' : ''}`;
        } else {
          return `1 Month`;
        }
      } else {
        if (remainingDays != 0) {
          return `${days} Day${days !== 1 ? 's' : ''}`;
        } else {
          return `1 Month`;
        }
      }
    } else {
      return `${days} Day${days !== 1 ? 's' : ''}`;
    }
  }
  varifyAction() {
    this.isGSTVerified = true;
    if (this.isGST && this.txtGst && this.validateGST(this.txtGst) && !this.gstinTracked) {
      this.gstinTracked = true;
      this.billingAnalytics.track('gstin_added');
    }
  }

  checkGST() {
    if (this.isGST) {
      if (this.isGSTVerified) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }
  validateGST(gstNumber) {
    const gstinPattern = /^([0-9]{2})([A-Z]{5})([0-9]{4})([A-Z]{1})([0-9]{1})([A-Z]{2})$/;
    const gstinPattern2 = /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/

    if (gstNumber.match(gstinPattern) || gstNumber.match(gstinPattern2)) {
      return true;
    } else {
      return false;
    }
  }

  calculateTotalPriceWithGST(): number {
    this.determinePaymentParameters();
    if (this.determined_tax_type === 'cgst_sgst' || this.determined_tax_type === 'igst') {
      const gstRate = 18;
      const gstAmount = (this.totalUser * gstRate) / 100;
      this.gstPrice = Number(gstAmount.toFixed(2));
      return this.gstPrice;
    } else {
      this.gstPrice = 0;
      return 0;
    }
  }

  calculateTotal(): number {
    this.determinePaymentParameters();
    let totalBill = this.totalUser;
    if (this.determined_tax_type === 'cgst_sgst' || this.determined_tax_type === 'igst') {
      totalBill += this.gstPrice;
    }
    return Number(totalBill.toFixed(2));
  }

  calculateTotalUSD(): number {
    return Number(this.totalUser_usd.toFixed(2));
  }

  /** True when product tour is not running (historically misnamed isTourActive). */
  isTourInactive() {
    if (localStorage.getItem('isTour')) {
      return localStorage.getItem('isTour') == 'false';
    }
    return true;
  }

  hasBillingDetails(): boolean {
    return !!this.billing_country;
  }

  private purchasePlanExtra(): { target_plan_code?: string } | undefined {
    if (this.checkoutMode === 'tier_upgrade' || this.selected_plan_type === 'tier_upgrade') {
      return { target_plan_code: this.checkoutPlanCode };
    }
    return undefined;
  }

  /** Build proration / renewal captions from server days_data (SUSEE-1547 T6). */
  private applyDaysDataCaptions(data: any): void {
    this.strCaption = '';
    this.strDateCption = '';
    this.strSubCaption = '';
    this.strSubDateCaption = '';
    this.summaryBreakdown = [];

    const daysData = data?.days_data || {};
    const periodSlug = billingPeriodLabelToSlug(this.plan_type);
    const termLabel = periodTermLabel(periodSlug);
    const currencyPrefix = this.billing_country === 'IN' ? '₹' : '$';
    const perSeat = Number(
      this.billing_country === 'IN' ? this.selected_price : this.selected_usd_price
    ) || 0;
    const productTotal =
      this.billing_country === 'IN'
        ? Number(this.totalUser) || 0
        : Number(this.totalUser_usd) || 0;

    if (this.checkoutMode === 'tier_upgrade' && data?.tier_upgrade) {
      const tu = data.tier_upgrade;
      const days = Number(tu.days_remaining) || Number(daysData?.base?.days) || 0;
      this.summaryBreakdown = [
        {
          label: `${this.user} seat${Number(this.user) === 1 ? '' : 's'} · ${days} day${days === 1 ? '' : 's'} left in this term`,
          amount: productTotal > 0 ? this.money(productTotal) : undefined,
        },
      ];
      if (tu.renew_amount != null && this.expire_date) {
        this.summaryBreakdown.push({
          label: `From ${this.formattedDate(this.expire_date)}: ${currencyPrefix}${tu.renew_amount} / ${termLabel}`,
        });
      }
      return;
    }

    if (this.selected_plan_type === 'addon' && daysData.addon) {
      const n = Number(daysData.addon.users) || Number(this.user) || 0;
      const days = Number(daysData.addon.days) || 0;
      this.summaryBreakdown = [
        {
          label: `${n} new seat${n !== 1 ? 's' : ''} · ${days} day${days !== 1 ? 's' : ''} left in this term`,
          amount: productTotal > 0 ? this.money(productTotal) : undefined,
        },
      ];
      const totalSeats = Number(this.quota_allowed || 0) + n;
      if (this.expire_date) {
        this.summaryBreakdown.push({
          label: `From ${this.formattedDate(this.expire_date)}: ${totalSeats} seats at ${currencyPrefix}${perSeat} / ${termLabel}`,
        });
      }
      this.strCaption = this.summaryBreakdown[0]?.label || '';
      return;
    }

    const baseUsers = Number(daysData?.base?.users) || 0;
    const baseDays = Number(daysData?.base?.days) || 0;
    const addonUsers = Number(daysData?.addon?.users) || 0;
    const addonDays = Number(daysData?.addon?.days) || 0;

    // Full-term quote (reactivation / new purchase): no mid-cycle split —
    // use the simple "N seats × rate" summary line with a verifiable amount.
    if (baseUsers > 0 && addonUsers === 0) {
      return;
    }

    if (baseUsers > 0 || addonUsers > 0) {
      const baseAmount = perSeat > 0 ? Number((perSeat * baseUsers).toFixed(2)) : 0;
      if (baseUsers > 0) {
        this.summaryBreakdown.push({
          label: `${baseUsers} current seat${baseUsers === 1 ? '' : 's'} · ${this.formatChargeTerm(
            baseDays,
            periodSlug
          )}`,
          amount: baseAmount > 0 ? this.money(baseAmount) : undefined,
        });
      }
      if (addonUsers > 0) {
        const aligned = addonDays > baseDays && baseDays > 0;
        const addonAmount =
          productTotal > 0 && baseAmount > 0
            ? Number((productTotal - baseAmount).toFixed(2))
            : perSeat > 0
              ? Number((perSeat * addonUsers).toFixed(2))
              : 0;
        this.summaryBreakdown.push({
          label: `${addonUsers} additional seat${addonUsers === 1 ? '' : 's'} · ${this.formatChargeTerm(
            addonDays,
            periodSlug
          )}`,
          hint: aligned
            ? 'Extra days keep new seats on the same renewal date as your current seats'
            : undefined,
          amount: addonAmount > 0 ? this.money(addonAmount) : undefined,
        });
      }
      return;
    }

    // Last-resort legacy strings (should rarely run).
    const isMonthly = this.plan_type === 'Monthly';
    const plan_dates = this._projectService.getExpiryStrings(daysData, isMonthly);
    if (plan_dates.addon_plan) {
      this.strSubCaption = plan_dates.addon_plan.addon_users;
      this.strSubDateCaption = plan_dates.addon_plan.addon_string;
    }
    if (plan_dates.base_plan) {
      this.strCaption = plan_dates.base_plan.base_users;
      this.strDateCption = plan_dates.base_plan.base_string;
    }
  }

  /** Human term length from quote day counts (avoids “User's / Day's”). */
  private formatChargeTerm(days: number, periodSlug: BillingPeriodSlug): string {
    const d = Math.max(0, Math.trunc(Number(days) || 0));
    if (periodSlug === 'yearly') {
      if (d === 0 || d === 365) {
        return '1 year';
      }
      if (d > 365) {
        const extra = d - 365;
        return `1 year + ${extra} day${extra === 1 ? '' : 's'}`;
      }
      return `${d} day${d === 1 ? '' : 's'}`;
    }
    if (periodSlug === 'quarterly') {
      if (d === 0 || d === 90) {
        return '1 quarter';
      }
      if (d > 90) {
        const extra = d - 90;
        return `1 quarter + ${extra} day${extra === 1 ? '' : 's'}`;
      }
      return `${d} day${d === 1 ? '' : 's'}`;
    }
    if (d === 0 || d === 30) {
      return '1 month';
    }
    if (d > 30) {
      const extra = d - 30;
      return `1 month + ${extra} day${extra === 1 ? '' : 's'}`;
    }
    return `${d} day${d === 1 ? '' : 's'}`;
  }

  private openRazorpayCheckout(
    paymentId: string,
    amount: number | string,
    callbackUrl: string,
    currency: string,
    key: string
  ): void {
    this.paymentOutcome = 'idle';
    this.paymentOutcomeMessage = '';
    this._wrs.payWithRazor(
      this.name,
      this.email,
      this.phone_number,
      paymentId,
      amount,
      callbackUrl,
      currency,
      key,
      this.auto_renew,
      {
        onSuccess: () => {
          const until = this.expire_date
            ? this.formattedDate(this.expire_date)
            : this.quota_expired_date || '';
          this.paymentOutcome = 'success';
          this.paymentOutcomeMessage = until
            ? `Payment received. ${this.user} seats active until ${until}. Invoice emailed to ${this.email || 'your billing email'}.`
            : `Payment received. ${this.user} seats are now active. Invoice emailed to ${this.email || 'your billing email'}.`;
          if (this.checkoutMode === 'tier_upgrade') {
            this.billingAnalytics.track('tier_upgrade_paid', {
              from: this.currentPlanCode,
              to: this.checkoutPlanCode,
            });
          }
          this.billingAnalytics.track('payment_succeeded', {
            seats: this.user,
            mode: this.checkoutMode,
          });
        },
        onDismiss: () => {
          this.billingAnalytics.track('payment_dismissed', { mode: this.checkoutMode });
        },
        onFailure: (error) => {
          this.paymentOutcome = 'failed';
          this.paymentOutcomeMessage =
            "Payment didn't go through. You weren't charged. Try again or use another method.";
          this.billingAnalytics.track('payment_failed', {
            reason: (error as any)?.description || (error as any)?.reason || 'failed',
            mode: this.checkoutMode,
          });
        },
      }
    );
  }

  clearPaymentOutcome(): void {
    this.paymentOutcome = 'idle';
    this.paymentOutcomeMessage = '';
  }

  getRemainingDate(strDate) {
    let date1 = new Date(strDate);
    let date2 = new Date();
    var diff = Math.floor(date1.getTime() - date2.getTime());
    var day = 1000 * 60 * 60 * 24;
    var days = Math.floor(diff / day);
    return days;
  }

  private applySavedTaxNumber(meta: { tax_no?: unknown } | null | undefined): void {
    const prefill = checkoutTaxPrefillFromSavedTaxNo(this.billing_country, meta?.tax_no);
    if (!prefill) {
      return;
    }
    this.isGST = prefill.isGST;
    this.txtGst = prefill.txtGst;
    this.isGSTVerified = prefill.isGSTVerified;
  }

  determinePaymentParameters() {
    if (this.billing_country === 'IN') {
      this.payment_mode = 'domestic';
      if (this.billing_state === 'GJ') {
        this.determined_tax_type = 'cgst_sgst';
      } else if (this.billing_state && this.billing_state !== 'GJ') {
        this.determined_tax_type = 'igst';
      } else {
        this.determined_tax_type = 'no_gst_state_provided';
      }
    } else {
      this.payment_mode = 'international';
      this.determined_tax_type = 'international';
    }
  }

  initiateRazorpayPayment() {
    console.log('Initiating Razorpay Payment...');
    this.loading = true;
    this.isButtonDisable = true;
    this.determinePaymentParameters();

    let taxInfo: { gst?: string, igst?: string } | null = null;

    if (this.payment_mode === 'domestic') {
      if (this.isGST && this.txtGst && this.txtGst.trim() !== '') {
        if (this.determined_tax_type === 'cgst_sgst') {
          taxInfo = { gst: this.txtGst };
        } else if (this.determined_tax_type === 'igst') {
          taxInfo = { igst: this.txtGst };
        }
      }
    }

    const isDowngrade = isProductTierDowngrade(this.currentPlanCode, this.checkoutPlanCode);
    if (isDowngrade) {
      this.submitTierChangeFromCheckout(this.checkoutPlanCode, taxInfo);
      return;
    }

    this._projectService.purchasePlan(
      this.plan_id,
      this.user,
      this.selected_plan_type,
      taxInfo,
      this.payment_mode,
      this.auto_renew,
      true,
      null,
      this.purchasePlanExtra()
    )
      .subscribe((data: any) => {
        this.loading = false;
        this.isButtonDisable = false;
        console.log("data", data)
        this.isSetDebounceTime = false;
        if (data && data.amount && data.callback_url) {
          let paymentId: string | null = null;

          if (data.subscription_id) {
            paymentId = data.subscription_id;
          } else if (data.order_id) {
            paymentId = data.order_id;
            this.order_Id = data.order_id;
          }

          if (paymentId) {
            const paymentCurrency = this.payment_mode === 'international' ? 'USD' : 'INR';
            const razorpayKey = data.key;
            this.openRazorpayCheckout(
              paymentId,
              data.amount,
              data.callback_url,
              paymentCurrency,
              razorpayKey
            );
          } else {
            this._snackBar.open('Payment ID (order or subscription) missing in response. Please try again.', 'Close', { duration: 3000 });
          }
        } else if (data && data.message) {
          this._snackBar.open(data.message, 'Close', { duration: 3000 });
        } else {
          this._snackBar.open('Failed to retrieve complete payment details. Please try again.', 'Close', { duration: 3000 });
        }
      }, (error) => {
        this.loading = false;
        this.isButtonDisable = false;
        this.isSetDebounceTime = false;

        const errorMessage = (error && error.error && error.error.message) ? error.error.message : 'Error initiating payment. Please try again.';

        if (error && error.error && error.error.code == "rest_plan_downgrade") {
          this.handlePlanDowngradeError(error);
        } else {
          this._snackBar.open(errorMessage, 'Close', { duration: 3000 });
        }
      });
  }

  private submitTierChangeFromCheckout(planCode: string, taxInfo?: { gst?: string; igst?: string }): void {
    const normalizedPlanCode = this.normalizedTierCode(planCode);
    this.tierActionPlanCode = normalizedPlanCode;

    const planId = this.resolvePlanIdForCode(normalizedPlanCode);
    const qty = this.user || this.quota_allowed || 1;
    const type = 'main';
    const mode = this.payment_mode || (this.billing_country === 'IN' ? 'domestic' : 'international');
    const autoRenew = this.auto_renew;
    const createOrder = true;

    this._projectService
      .requestProductTierChange(normalizedPlanCode, {
        transitionValidated: true,
        plan_id: planId,
        qty: qty,
        type: type,
        mode: mode,
        auto_renew: autoRenew,
        create_order: createOrder
      })
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.isButtonDisable = false;
          this.tierActionPlanCode = null;
          this.isSetDebounceTime = false;

          if (data.current_plan_code) {
            this.currentPlanCode =
              normalizeProductTierCode(data.current_plan_code) || data.current_plan_code;
            this.productTierDisplay = planCodeDisplayName(data.current_plan_code);
            this.currentSelectedPlant = this.productTierDisplay;
          }

          if (data.applied) {
            const appliedPlanCode =
              normalizeProductTierCode(data.current_plan_code || normalizedPlanCode) ||
              normalizedPlanCode;
            this._snackBar.open(
              data.message ||
              `Your plan is now ${planCodeDisplayName(appliedPlanCode)}. Billing and entitlements have been updated.`,
              'Close',
              { duration: 8000 }
            );
            this.refreshBillingAfterTierApplied(appliedPlanCode);
            return;
          }

          if (data && data.amount && data.callback_url) {
            let paymentId: string | null = null;
            if (data.subscription_id) {
              paymentId = data.subscription_id;
            } else if (data.order_id) {
              paymentId = data.order_id;
              this.order_Id = data.order_id;
            }

            if (paymentId) {
              const paymentCurrency = this.payment_mode === 'international' ? 'USD' : 'INR';
              const razorpayKey = data.key;
              this.openRazorpayCheckout(
                paymentId,
                data.amount,
                data.callback_url,
                paymentCurrency,
                razorpayKey
              );
            } else {
              this._snackBar.open('Payment ID (order or subscription) missing in response. Please try again.', 'Close', { duration: 3000 });
            }
          } else if (data && data.message) {
            this._snackBar.open(data.message, 'Close', { duration: 3000 });
          } else {
            this._snackBar.open('Failed to retrieve complete payment details. Please try again.', 'Close', { duration: 3000 });
          }
        },
        error: (err) => {
          this.loading = false;
          this.isButtonDisable = false;
          this.tierActionPlanCode = null;
          this.isSetDebounceTime = false;
          const msg =
            err?.error?.message || 'Could not update product tier. Please try again.';
          this._snackBar.open(msg, 'Close', { duration: 7000 });
        }
      });
  }

  getBillingDetails() {
    if (!this.canRequestBillingQuote()) {
      return;
    }
    const quoteSeq = ++this.billingQuoteSeq;
    this.determinePaymentParameters();
    let taxInfo: { gst?: string, igst?: string } | null = null;
    if (this.payment_mode === 'domestic') {
      if (this.isGST && this.txtGst && this.txtGst.trim() !== '') {
        if (this.determined_tax_type === 'cgst_sgst') {
          taxInfo = { gst: this.txtGst };
        } else if (this.determined_tax_type === 'igst') {
          taxInfo = { igst: this.txtGst };
        }
      }
    }
    this.isLoadingPrice = true;

    const handleBillingDetailsSuccess = (data: any) => {
      if (quoteSeq !== this.billingQuoteSeq || this.destroyed) {
        return;
      }
      this.isLoadingPrice = false;
      this.quoteErrorMessage = '';
      this.quoteSeatsShortfall = null;
      this.quoteRequiredSeats = null;
      if (data && data.breakage) {
        if (this.payment_mode === 'domestic') {
          this.totalUser = parseBillingAmount(data.breakage.product);
          this.totalUser_usd = 0;
          this.gstPrice = parseBillingAmount(data.breakage.gst);
          this.totalInr = parseBillingAmount(data.breakage.amount);
          this.totalUsd = 0;
        } else {
          this.totalUser_usd = parseBillingAmount(data.breakage.amount);
          this.totalUser = 0;
          this.gstPrice = 0;
          this.totalInr = 0;
          this.totalUsd = this.totalUser_usd;
        }
      } else {
        this.totalUser = 0;
        this.totalUser_usd = 0;
        this.gstPrice = 0;
        this.totalInr = 0;
        this.totalUsd = 0;
      }

      this.applyDaysDataCaptions(data);
    };

    const handleBillingDetailsError = (error: any) => {
      if (quoteSeq !== this.billingQuoteSeq || this.destroyed) {
        return;
      }
      this.isLoadingPrice = false;
      let errorMessage = "";
      if (error && error.error && error.error.message) {
        errorMessage = error.error.message;
      }
      this.quoteErrorMessage = errorMessage || 'Could not refresh the price. Try again.';
      this.quoteSeatsShortfall = null;
      this.quoteRequiredSeats = null;
      let seatShortfallHandled = false;
      if (error && error.error && error.error.code == "rest_plan_downgrade") {
        if (this.applySeatShortfallFromQuoteError(error)) {
          seatShortfallHandled = true;
        } else {
          this.handlePlanDowngradeError(error);
        }
      } else if (errorMessage) {
        this._snackBar.open(errorMessage, 'Close', { duration: 3000 });
      }
      const errCode = error?.error?.code || '';
      if (errCode && errCode !== 'rest_invalid_plan') {
        console.error('Error in getBillingDetails:', error);
      }
      // Don't flash $0 while we auto-bump seats / wait for re-quote.
      if (!seatShortfallHandled) {
        this.totalUser = 0;
        this.gstPrice = 0;
        this.totalInr = 0;
        this.totalUsd = 0;
        this.totalUser_usd = 0;
        this.summaryBreakdown = [];
      }
    };

    const isDowngrade = isProductTierDowngrade(this.currentPlanCode, this.checkoutPlanCode);
    if (isDowngrade) {
      this._projectService.requestProductTierChange(this.checkoutPlanCode, {
        transitionValidated: true,
        plan_id: this.plan_id,
        qty: this.user,
        type: 'main',
        mode: this.payment_mode || (this.billing_country === 'IN' ? 'domestic' : 'international'),
        auto_renew: this.auto_renew,
        create_order: false
      }).subscribe(handleBillingDetailsSuccess, handleBillingDetailsError);
    } else {
      this._projectService.purchasePlan(
        this.plan_id,
        this.user,
        this.selected_plan_type,
        taxInfo,
        this.payment_mode,
        this.auto_renew,
        false,
        null,
        this.purchasePlanExtra()
      )
        .subscribe(handleBillingDetailsSuccess, handleBillingDetailsError);
    }
  }

  showAddonRenewalRestrictionDialog(): void {
    const activeAddonDetails = this.getActiveAddonDetails();
    const hintList = activeAddonDetails.map(detail => ({
      icon: detail.icon,
      text: detail.label,
      color: detail.color
    }));

    const hintFooter = this.isPaidSubscriptionActive()
      ? 'Your existing features will remain active until your subscription expires.'
      : 'Your custom add-on features will be reactivated once the renewal process is complete.';

    const ref = this._dialog.open(PlanUpgradeDialogComponent, {
      width: 'auto',
      maxWidth: '540px',
      data: {
        title: 'Contact Support to Renew',
        message: "Your current subscription includes custom add-ons that require manual renewal. To keep these features active, please contact our support team and we'll help you renew your plan.",
        hintTitle: 'Your current custom add-ons:',
        hintList: hintList,
        hintFooter: hintFooter,
        icon: 'help',
        confirmLabel: 'Renew with Support',
        cancelLabel: 'Close',
      },
    });

    ref.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this._dialog.open(CreateRequestComponent, {
          width: '500px',
          maxWidth: '95vw',
          panelClass: 'create-request-modal',
          disableClose: true,
          data: { type: 'support', source: 'page' }
        });
      }
    });
  }

  showAddonDowngradeRestrictionDialog(): void {
    const activeAddonDetails = this.getActiveAddonDetails();
    const hintList = activeAddonDetails.map(detail => ({ 
      icon: detail.icon, 
      text: detail.label,
      color: detail.color 
    }));
    
    const hintFooter = 'Your custom add-on features must be adjusted by our support team before downgrading your plan.';

    const ref = this._dialog.open(PlanUpgradeDialogComponent, {
      width: 'auto',
      maxWidth: '540px',
      data: {
        title: 'Contact Support to Downgrade',
        message: "Your current subscription includes custom add-ons. To downgrade your plan, please contact our support team and we'll help you adjust your workspace features.",
        hintTitle: 'Your active custom add-ons:',
        hintList: hintList,
        hintFooter: hintFooter,
        icon: 'help',
        confirmLabel: 'Contact Support',
        cancelLabel: 'Close',
      },
    });

    ref.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this._dialog.open(CreateRequestComponent, {
          width: '500px',
          maxWidth: '95vw',
          panelClass: 'create-request-modal',
          disableClose: true,
          data: { type: 'support', source: 'page' }
        });
      }
    });
  }

  showAddonUpgradeRestrictionDialog(): void {
    const activeAddonDetails = this.getActiveAddonDetails();
    const hintList = activeAddonDetails.map(detail => ({ 
      icon: detail.icon, 
      text: detail.label,
      color: detail.color 
    }));
    
    const hintFooter = 'Your custom add-on features must be adjusted by our support team before upgrading your plan.';

    const ref = this._dialog.open(PlanUpgradeDialogComponent, {
      width: 'auto',
      maxWidth: '540px',
      data: {
        title: 'Contact Support to Upgrade',
        message: "Your current subscription includes custom add-ons. To upgrade your plan, please contact our support team and we'll help you adjust your workspace features.",
        hintTitle: 'Your active custom add-ons:',
        hintList: hintList,
        hintFooter: hintFooter,
        icon: 'help',
        confirmLabel: 'Contact Support',
        cancelLabel: 'Close',
      },
    });

    ref.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this._dialog.open(CreateRequestComponent, {
          width: '500px',
          maxWidth: '95vw',
          panelClass: 'create-request-modal',
          disableClose: true,
          data: { type: 'support', source: 'page' }
        });
      }
    });
  }

  initiateUpgrade() {
    this.determinePaymentParameters();
    this.billingAnalytics.track('pay_clicked', {
      amount: this.billing_country === 'IN' ? this.resolveCheckoutPayableInr() : this.resolveCheckoutPayableUsd(),
      currency: this.billing_country === 'IN' ? 'INR' : 'USD',
      period: billingPeriodLabelToSlug(this.plan_type),
      seats: this.user,
      tier: this.checkoutPlanCode || this.currentPlanCode,
      mode: this.checkoutMode,
    });

    // Same-plan renew/reactivate must reach Razorpay even when add-ons are present.
    // Only block mid-pay when the customer is changing product tier with active add-ons.
    if (
      this.hasActiveAddons &&
      this.checkoutPlanCode &&
      this.checkoutPlanCode !== this.currentPlanCode &&
      this.planTierRank(this.checkoutPlanCode) > this.planTierRank(this.currentPlanCode)
    ) {
      this.showAddonUpgradeRestrictionDialog();
      return;
    }

    if (!this.user || this.user < this.min && !this.isAdvancePayment) {
      this._snackBar.open(`Minimum ${this.min} user${this.min !== 1 ? 's' : ''} required.`, 'Close', { duration: 3000 });
      this.isHint = true;
      return;
    }

    if (this.billing_country === 'IN' && this.isGST && !this.isGSTVerified && this.txtGst !== '') {
      this._snackBar.open('Please verify your GST number.', 'Close', { duration: 3000 });
      return;
    }
    if (this.billing_country === 'IN' && this.isGST && this.txtGst === '') {
      this._snackBar.open('Please enter your GST number.', 'Close', { duration: 3000 });
      return;
    }

    this.determinePaymentParameters();

    // Show confirmation dialog if auto-renew is enabled
    this.validateAutoRenewState().then((confirmed) => {
      if (confirmed) {
        this.initiateRazorpayPayment();
      }
    });
  }

  checkoutCtaLabel(): string {
    const isDowngrade = isProductTierDowngrade(this.currentPlanCode, this.checkoutPlanCode);
    const amount = this.billing_country === 'IN' ? this.resolveCheckoutPayableInr() : this.resolveCheckoutPayableUsd();
    if (amount <= 0) {
      return isDowngrade ? 'Confirm Downgrade' : 'Confirm Plan';
    }
    // Always show payable amount on the primary CTA (addon / renew / setup / tier upgrade).
    if (this.billing_country === 'IN') {
      const formatted = formatInrCheckoutAmount(amount);
      return formatted ? `Pay ₹${formatted}` : 'Pay';
    }
    return `Pay $${amount.toFixed(2)}`;
  }

  /** Pay CTA must match billing summary; quote totals may arrive comma-formatted. */
  private resolveCheckoutPayableInr(): number {
    const quoted = parseBillingAmount(this.totalInr);
    if (quoted > 0) {
      return quoted;
    }
    const computed = this.calculateTotal();
    return computed > 0 ? computed : 0;
  }

  private resolveCheckoutPayableUsd(): number {
    const quoted = parseBillingAmount(this.totalUsd);
    if (quoted > 0) {
      return quoted;
    }
    return this.calculateTotalUSD();
  }

  openBillingDialog() {
    // Function to actually open the billing dialog
    const showBillingDialog = () => {
      if (this.loginUserInformation) {
        this.applyBillingLocationFromUser(this.loginUserInformation);
      }
      const dialogRef = this.trackDialog(
        this._dialog.open(BillingProfileModalComponent, {
          panelClass: 'billing-dialog',
          width: '600px',
          disableClose: true,
          data: {
            billing_address: this.loginUserInformation?.billing_address || {},
            meta: this.loginUserInformation?.meta || {},
            editing: this.hasSavedBillingProfile(),
          },
          maxHeight: '90vh',
        })
      );

      dialogRef.afterClosed().subscribe(result => {
        this.isSetDebounceTime = false;
        if (result) {
          this.phone_number = result?.phoneNumber;
          if (this.phone_number && this.loginUserInformation?.meta) {
            this.loginUserInformation.meta.phone_number = this.phone_number;
            if (!this.loginUserInformation.billing_address) {
              this.loginUserInformation.billing_address = {};
            }
            this.loginUserInformation.billing_address.phone = this.phone_number;
          }
          if (result.billing) {
            // Drop any /users/me that started while the form was open, then
            // show the country the customer just saved and price that country.
            this.userFetchSeq++;
            this.rememberSavedBillingAddress(result.billing);
            this.reapplySavedBillingAddress();
          }
          this.getUser();
        }
      });
    };

    // Match the profile page: a saved number, the server flag, or an OTP
    // already completed in this browser means the phone step is done.
    const payloadPhone = (this.loginUserInformation?.meta?.phone_number || '').toString().trim();
    const knownPhone =
      (this.phone_number && this.phone_number.toString().trim()) || payloadPhone;
    const phoneVerified =
      this.phoneVerificationService.hasCompletedPhoneVerification(this.loginUserInformation);
    console.info('[Billing] openBillingDialog gate decision', {
      needsPhoneOtp: !phoneVerified,
      phoneVerified,
      knownPhone: knownPhone || '(empty)',
      raoPhoneVerified: this.loginUserInformation?.meta?.rao_phone_verified ?? '(unset)',
    });

    if (!phoneVerified) {
      const dialogRefPhoneVerification = this.trackDialog(
        this._dialog.open(PhoneVerificationModalComponent, {
          width: window.innerWidth < 600 ? '100vw' : '90vw',
          height: 'auto',
          maxWidth: window.innerWidth < 600 ? '100vw' : '500px',
          maxHeight: window.innerWidth < 600 ? '85vh' : '95vh',
          disableClose: true,
          panelClass: ['phone-verification-dialog', window.innerWidth < 600 ? 'mobile-dialog' : ''],
          data: {
            title: 'Verify Your Phone Number',
            message: 'Please verify your phone number before adding billing information.',
            skipable: false,
            phoneNumber: knownPhone || undefined,
          },
        })
      );

      dialogRefPhoneVerification.afterClosed().subscribe(result => {
        if (result && result.verified) {
          if (result.phoneNumber) {
            this.phone_number = result.phoneNumber;
            if (this.loginUserInformation?.meta) {
              this.loginUserInformation.meta.phone_number = result.phoneNumber;
              this.loginUserInformation.meta.rao_phone_verified = '1';
            }
          }
          showBillingDialog();
        }
      });
      return;
    }
    showBillingDialog();
  }


}
